import type { Messages } from "./en";

export const bn: Messages = {
  common: {
    appName: "জিটা",
    continue: "এগিয়ে যান",
    back: "পেছনে",
    save: "সংরক্ষণ করুন",
    cancel: "বাতিল",
    signOut: "সাইন আউট",
    loading: "লোড হচ্ছে…",
    retry: "আবার চেষ্টা করুন",
    optional: "ঐচ্ছিক",
    language: "ভাষা",
    account: "অ্যাকাউন্ট",
    switchBusiness: "ব্যবসা পরিবর্তন",
    addBusiness: "নতুন ব্যবসা যোগ করুন",
  },
  errors: {
    generic: "কিছু একটা সমস্যা হয়েছে। আবার চেষ্টা করুন।",
    network_error: "ইন্টারনেট সংযোগ নেই। সংযোগ দেখে আবার চেষ্টা করুন।",
    otp_invalid: "কোডটি সঠিক নয়।",
    otp_expired: "কোডের মেয়াদ শেষ। নতুন কোড নিন।",
    otp_attempts_exceeded: "অনেকবার ভুল হয়েছে। নতুন কোড নিন।",
    captcha_failed: "যাচাই ব্যর্থ হয়েছে। আবার চেষ্টা করুন।",
    rate_limited: "অনেকবার চেষ্টা করা হয়েছে। একটু অপেক্ষা করে আবার চেষ্টা করুন।",
    service_unavailable: "সার্ভিস এখন ব্যস্ত। কিছুক্ষণ পর আবার চেষ্টা করুন।",
    validation_failed: "চিহ্নিত ঘরগুলো ঠিক করুন।",
    conflict: "এটি সম্পন্ন করা যায়নি।",
    tenant_not_ready: "ব্যবসাটি এখনও সেটআপ হচ্ছে।",
    forbidden: "এটি করার অনুমতি আপনার নেই।",
    not_found: "পাওয়া যায়নি।",
    plan_limit_reached: "আপনার প্ল্যানে এটি নেই। প্ল্যান ও বিলিং থেকে আপগ্রেড করুন।",
    step_up_required: "অ্যাডমিন সেশন বন্ধ হয়েছে। আবার নিশ্চিত করুন এটি আপনি।",
    maintenance: "এখন রক্ষণাবেক্ষণের জন্য Zeeta শুধু দেখার মোডে। একটু পরে চেষ্টা করুন।",
  },
  auth: {
    forgotLink: "পাসওয়ার্ড ভুলে গেছেন?",
    backToSignIn: "সাইন ইনে ফিরে যান",
    resetTitle: "পাসওয়ার্ড নতুন করুন",
    resetSubtitle: "আপনার জিমেইলে ৬ অঙ্কের কোড পাঠাব। তারপর নতুন পাসওয়ার্ড দিন।",
    resetSend: "কোড ইমেইল করুন",
    resetSent: "{email}-এ Zeeta অ্যাকাউন্ট থাকলে ৬ অঙ্কের কোড পাঠানো হয়েছে। কোড ও নতুন পাসওয়ার্ড দিন।",
    resetSentToMe: "{email}-এ ৬ অঙ্কের কোড পাঠানো হয়েছে। কোড ও নতুন পাসওয়ার্ড দিন।",
    resetSave: "নতুন পাসওয়ার্ড সেট করুন",
    title: "জিটায় সাইন ইন করুন",
    subtitle: "নতুন? সাইন ইন করলেই আপনার অ্যাকাউন্ট তৈরি হবে।",
    google: "Google দিয়ে চালিয়ে যান",
    or: "অথবা",
    tabCode: "ইমেইল কোড",
    tabPassword: "পাসওয়ার্ড",
    emailLabel: "Gmail ঠিকানা",
    emailPlaceholder: "you@gmail.com",
    emailInvalid: "Gmail ঠিকানা দিন (@gmail.com দিয়ে শেষ)",
    passwordLabel: "পাসওয়ার্ড",
    signIn: "সাইন ইন",
    sendCode: "কোড পাঠান",
    codeSentToEmail: "{email} আপনার Gmail হলে সেখানে ৬ সংখ্যার কোড পাঠানো হয়েছে। Spam ফোল্ডারও দেখুন।",
    codeSentTo: "{phone} নম্বরে পাঠানো কোডটি লিখুন",
    codeLabel: "৬ সংখ্যার কোড",
    verify: "যাচাই করে এগিয়ে যান",
    trustDevice: "এই ডিভাইসে ৩০ দিন সাইন ইন রাখুন",
    resendIn: "{seconds} সেকেন্ড পর আবার কোড পাঠানো যাবে",
    resend: "আবার কোড পাঠান",
    changeEmail: "অন্য ইমেইল ব্যবহার করুন",
    changeNumber: "নম্বর পরিবর্তন করুন",
    emailLink: "Gmail দিয়ে সাইন ইন করুন",
    phoneTitle: "মোবাইল নম্বর দিয়ে সাইন ইন",
    phoneSubtitle: "যেসব অ্যাকাউন্ট ফোন নম্বর দিয়ে খোলা হয়েছিল। আপনাকে Gmail যোগ করতে বলা হবে।",
    phoneLabel: "মোবাইল নম্বর",
    phonePlaceholder: "০১XXXXXXXXX",
    phoneInvalid: "সঠিক বাংলাদেশি মোবাইল নম্বর দিন",
    errors: {
      google_unavailable: "এখন Google দিয়ে সাইন ইন করা যাচ্ছে না। ইমেইল কোড ব্যবহার করুন।",
      google_cancelled: "Google সাইন ইন বাতিল করা হয়েছে।",
      google_expired: "Google সাইন ইনে অনেক সময় লেগেছে। আবার চেষ্টা করুন।",
      google_not_gmail: "ব্যক্তিগত Gmail অ্যাকাউন্ট ব্যবহার করুন। অফিস বা প্রতিষ্ঠানের Google অ্যাকাউন্ট চলবে না।",
      google_conflict: "এই Gmail ইতিমধ্যে অন্য একটি Google অ্যাকাউন্টের সাথে যুক্ত।",
      google_failed: "Google সাইন ইন কাজ করেনি। আবার চেষ্টা করুন বা ইমেইল কোড ব্যবহার করুন।",
    },
  },
  onboarding: {
    title: "আপনার ব্যবসা সেটআপ করুন",
    stepOf: "ধাপ {step} / {total}",
    profileTitle: "আপনার নাম কী?",
    profileSubtitle: "রসিদ ও মেসেজে আপনার কর্মী ও ক্রেতারা এই নাম দেখবেন।",
    yourName: "আপনার পুরো নাম",
    languageTitle: "ভাষা নির্বাচন করুন",
    languageSubtitle: "যেকোনো সময় পরিবর্তন করতে পারবেন।",
    typeTitle: "আপনার ব্যবসার ধরন কী?",
    typeSubtitle: "সেই অনুযায়ী একক, ক্যাটাগরি ও তথ্যের ঘর সাজিয়ে দেব।",
    comingSoon: "শীঘ্রই আসছে",
    detailsTitle: "ব্যবসার তথ্য",
    detailsSubtitle: "এটি আপনার রসিদ ও ইনভয়েসে দেখা যাবে।",
    shopName: "ব্যবসার নাম",
    shopPhone: "ব্যবসার ফোন নম্বর",
    division: "বিভাগ",
    district: "জেলা",
    upazila: "উপজেলা / থানা",
    addressLine: "ঠিকানা",
    addressPlaceholder: "বাড়ি, রোড, এলাকা",
    selectPlaceholder: "নির্বাচন করুন",
    bin: "ভ্যাট BIN",
    binHelp: "আপনার এনবিআর BIN। স্টার্টার প্ল্যানে সেটিংস থেকে মূসক ৬.৩ ভ্যাট ইনভয়েস চালু করা যাবে।",
    fieldInvalid: "এই ঘরটি ঠিক করুন",
    create: "ব্যবসা তৈরি করুন",
    creating: "আপনার ব্যবসা সেটআপ হচ্ছে…",
  },
  dashboard: {
    welcome: "স্বাগতম, {name}",
    welcomeNoName: "স্বাগতম",
    setupTitle: "সেটআপ সম্পন্ন করুন",
    setupProgress: "{total}টির মধ্যে {done}টি সম্পন্ন",
    dismiss: "তালিকা লুকান",
    markDone: "সম্পন্ন চিহ্নিত করুন",
    done: "সম্পন্ন",
    branches: "শাখা",
    main: "প্রধান",
    role: "আপনার ভূমিকা",
    salesToday: "আজকের বিক্রি",
    salesCount: "{count}টি বিক্রি",
    grossProfit: "মোট লাভ",
    cashInHand: "ড্রয়ারে নগদ",
    receivable: "ক্রেতাদের কাছে পাওনা",
    payable: "সরবরাহকারীদের দেনা",
    lowStock: "স্টক কম এমন পণ্য",
    nearExpiry: "৯০ দিনে মেয়াদ শেষ হবে এমন ব্যাচ",
    expired: "{count}টি মেয়াদোত্তীর্ণ ব্যাচ",
    trend: "বিক্রি, গত ৩০ দিন",
    newSale: "নতুন বিক্রি",
    newPurchase: "নতুন ক্রয়",
    addProduct: "পণ্য যোগ করুন",
    steps: {
      products: "আপনার পণ্য যোগ করুন",
      opening_stock: "শুরুর স্টক লিখুন",
      opening_dues: "ক্রেতা ও সরবরাহকারীর শুরুর বাকি লিখুন",
      printer: "রসিদ প্রিন্টার যুক্ত করুন",
      staff: "কর্মীদের আমন্ত্রণ জানান",
      payment_methods: "ক্যাশ, বিকাশ ও নগদ অ্যাকাউন্ট সেটআপ করুন",
      first_sale: "প্রথম বিক্রি করুন",
    },
  },
  ui: {
    item: "পণ্য",
    choose: "বেছে নিন…",
    copy: "কপি",
    copied: "কপি হয়েছে",
    search: "খুঁজুন",
    add: "যোগ করুন",
    edit: "সম্পাদনা",
    create: "তৈরি করুন",
    close: "বন্ধ করুন",
    confirm: "নিশ্চিত করুন",
    all: "সব",
    total: "মোট",
    date: "তারিখ",
    status: "অবস্থা",
    noResults: "কিছু পাওয়া যায়নি",
    loadMore: "আরও দেখুন",
    print: "প্রিন্ট",
    from: "থেকে",
    to: "পর্যন্ত",
    amount: "পরিমাণ",
    note: "নোট",
    reason: "কারণ",
    branch: "শাখা",
    qty: "পরিমাণ",
    unit: "একক",
    price: "দাম",
    cost: "ক্রয়মূল্য",
    name: "নাম",
    phone: "ফোন",
    address: "ঠিকানা",
    view: "দেখুন",
    remove: "সরান",
    saved: "সংরক্ষিত হয়েছে",
    active: "সক্রিয়",
    archived: "আর্কাইভ করা",
    archive: "আর্কাইভ",
    restore: "ফিরিয়ে আনুন",
    today: "আজ",
    last7: "গত ৭ দিন",
    last30: "গত ৩০ দিন",
  },
  nav: {
    couriers: "কুরিয়ার",
    storefront: "অনলাইন শপ",
    orders: "অনলাইন অর্ডার",
    developers: "ডেভেলপার",
    dashboard: "ড্যাশবোর্ড",
    pos: "বিক্রয় কাউন্টার",
    sales: "বিক্রি",
    products: "পণ্য",
    stock: "স্টক",
    purchases: "ক্রয়",
    customers: "ক্রেতা",
    suppliers: "সরবরাহকারী",
    accounts: "ক্যাশ ও অ্যাকাউন্ট",
    expenses: "খরচ",
    reports: "রিপোর্ট",
    vat: "ভ্যাট",
    settings: "সেটিংস",
    team: "টিম",
    billing: "প্ল্যান ও বিলিং",
    wholesale: "পাইকারি",
    loyalty: "লয়্যালটি ও ভাউচার",
    quotations: "কোটেশন",
    sessions: "অ্যাকাউন্ট ও নিরাপত্তা",
    more: "আরও",
  },
  products: {
    scanHint:
      "প্যাকের বারকোড স্ক্যান করুন (বা লিখে এন্টার চাপুন): Zeeta যা জানে পূরণ করে দেবে। একাধিক হলে কমা দিয়ে আলাদা করুন।",
    lookingUp: "বারকোড খোঁজা হচ্ছে…",
    alreadyHave: "এই বারকোড আগেই “{name}”-এ আছে।",
    openIt: "খুলুন",
    checkFilled: "বিবরণ দেখে নিন, দাম দিন, তারপর সংরক্ষণ করুন।",
    notFoundBarcode: "কোথাও পাওয়া যায়নি: বিবরণ লিখুন। সংরক্ষণের পর ক্যাশে স্ক্যান হবে।",
    stockNow: "{branch}-এ স্টক",
    stockQty: "এখন হাতে আছে",
    costPrice: "কেনা দাম (প্রতিটি)",
    costHint: "স্টকের মূল্য ও লাভের হিসাবের জন্য।",
    costNeeded: "প্রতিটির কেনা দাম দিন",
    moreDetails: "আরও বিবরণ: এমআরপি, ব্র্যান্ড, রিঅর্ডার লেভেল, ভ্যাট, প্যাক সাইজ, ছবি…",
    saveNext: "সংরক্ষণ ও পরেরটি",
    savedNext: "“{name}” সংরক্ষিত। পরের পণ্য স্ক্যান করুন।",
    stockPerVariant: "এই পণ্যের সাইজ বা রং আছে: সেগুলোর স্টক স্টক পাতায় দিন।",
    counted: "এখন গুনে পাওয়া",
    correctionWhy: "কারণ",
    correctionReason: "স্টক গণনা সংশোধন",
    correct: "স্টক ঠিক করুন",
    filledFrom: {
      library: "Zeeta-র বারকোড লাইব্রেরি থেকে পূরণ হয়েছে।",
      starter: "Zeeta-র শুরুর ক্যাটালগ থেকে পূরণ হয়েছে।",
      openfoodfacts: "পূরণ হয়েছে:",
    },
    online: "অনলাইন শপ",
    photos: "ছবি",
    descriptionBn: "বিবরণ (বাংলা)",
    descriptionEn: "বিবরণ (ইংরেজি)",
    onlineHidden: "অনলাইন শপে লুকান",
    onlineHiddenHint: "কাউন্টারে বিক্রি হবে; ওয়েবসাইট বা API ক্যাটালগে দেখাবে না।",
    title: "পণ্য",
    subtitle: "আপনার সব পণ্য, দাম ও স্টকসহ।",
    scanAnywhere: "এই পেজে পণ্যের বারকোড স্ক্যান করুন: নতুন হলে যোগ হবে, আগে থাকলে খুলবে।",
    add: "পণ্য যোগ করুন",
    editTitle: "পণ্য সম্পাদনা",
    nameEn: "নাম (ইংরেজি)",
    nameBn: "নাম (বাংলা)",
    nameHint: "অন্তত একটি দিন। দুটো দিয়েই খোঁজা যাবে।",
    category: "ক্যাটাগরি",
    noCategory: "ক্যাটাগরি নেই",
    newCategory: "নতুন ক্যাটাগরি",
    brand: "ব্র্যান্ড",
    baseUnit: "বিক্রির একক",
    salePrice: "বিক্রয়মূল্য",
    mrp: "এমআরপি",
    vatRate: "ভ্যাট %",
    sdRate: "এসডি %",
    reorderLevel: "স্টক কম হলে সতর্ক করুন",
    trackStock: "এই পণ্যের স্টক হিসাব রাখুন",
    sku: "এসকেইউ",
    skuAuto: "খালি রাখলে নিজে থেকে তৈরি হবে",
    barcodes: "বারকোড",
    barcodesHint: "স্ক্যান করুন বা লিখুন; একাধিক হলে কমা দিন।",
    packSizes: "প্যাকের সাইজ",
    packSizesHint: "বক্স বা পাতায় কেনা-বেচা করুন, যেমন ১ বক্স = ১০ পাতা।",
    addPackSize: "প্যাক সাইজ যোগ করুন",
    unitsPer: "একটিতে কত {unit}",
    packPrice: "প্যাকের দাম",
    onHand: "স্টকে আছে",
    lowStock: "স্টক কম",
    lowStockOnly: "শুধু কম স্টক",
    empty: "এখনও কোনো পণ্য নেই",
    emptyHint: "বিক্রি শুরু করতে প্রথম পণ্যটি যোগ করুন।",
    customFields: "আরও তথ্য",
    variants: "ভ্যারিয়েন্ট",
  },
  stock: {
    title: "স্টক",
    subtitle: "স্টকের পরিমাণ, ব্যাচ ও সংশোধন।",
    openingStock: "শুরুর স্টক",
    openingStockHint: "তাকে এখন যা আছে এবং তা কত দামে কিনেছিলেন লিখুন।",
    adjust: "স্টক সংশোধন",
    adjustTitle: "স্টক সংশোধন",
    type: "ধরন",
    types: {
      adjustment: "সংশোধন",
      damage: "নষ্ট",
      expiry_writeoff: "মেয়াদোত্তীর্ণ",
    },
    qtyChange: "পরিবর্তন (+ বা −)",
    qtyRemove: "কত সরাবেন",
    unitCost: "প্রতি এককের ক্রয়মূল্য",
    batchNo: "ব্যাচ",
    expiryDate: "মেয়াদ শেষের তারিখ",
    mfgDate: "উৎপাদনের তারিখ",
    lots: "ব্যাচসমূহ",
    nearExpiry: "শীঘ্রই মেয়াদ শেষ",
    expired: "মেয়াদোত্তীর্ণ",
    expires: "মেয়াদ",
    received: "গ্রহণ",
    movements: "স্টকের ইতিহাস",
    addLine: "পণ্য যোগ করুন",
    posted: "স্টক হালনাগাদ হয়েছে",
    value: "স্টকের মূল্য",
    movementTypes: {
      opening: "শুরুর স্টক",
      purchase: "ক্রয়",
      purchase_return: "সরবরাহকারীকে ফেরত",
      sale: "বিক্রি",
      sale_return: "ক্রেতার ফেরত",
      transfer_in: "স্থানান্তর (আগত)",
      transfer_out: "স্থানান্তর (বহির্গামী)",
      adjustment: "সংশোধন",
      damage: "নষ্ট",
      expiry_writeoff: "মেয়াদোত্তীর্ণ",
      count: "স্টক গণনা",
      deficit_settle: "খরচ সংশোধন",
    },
  },
  purchases: {
    title: "ক্রয়",
    subtitle: "সরবরাহকারীর কাছ থেকে পাওয়া মাল।",
    new: "নতুন ক্রয়",
    supplier: "সরবরাহকারী",
    selectSupplier: "সরবরাহকারী নির্বাচন করুন",
    supplierInvoiceNo: "সরবরাহকারীর ইনভয়েস নং",
    supplierInvoiceDate: "ইনভয়েসের তারিখ",
    lines: "পণ্যসমূহ",
    searchItem: "পণ্য খুঁজুন বা স্ক্যান করুন",
    unitCost: "ক্রয়মূল্য",
    discount: "ছাড়",
    vat: "ভ্যাট %",
    billDiscount: "বিলে ছাড়",
    landedCost: "পরিবহন ও অন্যান্য খরচ",
    landedHint: "পণ্যের ক্রয়মূল্যে যোগ হবে",
    allocation: "খরচ ভাগ হবে",
    byValue: "মূল্য অনুযায়ী",
    byQty: "পরিমাণ অনুযায়ী",
    payNow: "এখন পরিশোধ",
    payFrom: "যেখান থেকে পরিশোধ",
    paid: "পরিশোধিত",
    due: "বাকি",
    save: "ক্রয় সংরক্ষণ করুন",
    number: "জিআরএন নং",
    detail: "ক্রয়",
    return: "সরবরাহকারীকে ফেরত",
    returnQty: "ফেরতের পরিমাণ",
    refund: "ফেরত পাওয়া টাকা",
    refundTo: "টাকা জমা হবে",
    returned: "ফেরত",
    empty: "এখনও কোনো ক্রয় নেই",
    emptyHint: "স্টক ও সরবরাহকারীর বাকি ঠিক রাখতে পাওয়া মাল লিখে রাখুন।",
  },
  parties: {
    customers: "ক্রেতা",
    customersSubtitle: "ক্রেতার তালিকা ও বাকির খাতা।",
    suppliers: "সরবরাহকারী",
    suppliersSubtitle: "যাদের কাছ থেকে কেনেন এবং কত বাকি।",
    addCustomer: "ক্রেতা যোগ করুন",
    addSupplier: "সরবরাহকারী যোগ করুন",
    contactPerson: "যোগাযোগের ব্যক্তি",
    creditLimit: "বাকির সীমা",
    creditLimitHint: "সীমা না থাকলে খালি রাখুন।",
    openingBalance: "শুরুর বাকি",
    openingBalanceCustomerHint: "এই ক্রেতার কাছে আপনার আগের পাওনা।",
    openingBalanceSupplierHint: "এই সরবরাহকারীর কাছে আপনার আগের দেনা।",
    balance: "ব্যালেন্স",
    owesYou: "পাওনা",
    youOwe: "দেনা",
    ledger: "খাতা",
    collectDue: "বাকি আদায়",
    paySupplier: "পরিশোধ করুন",
    ageing: "বাকির বয়স",
    d0_30: "০–৩০ দিন",
    d31_60: "৩১–৬০ দিন",
    d61_90: "৬১–৯০ দিন",
    d90p: "৯০+ দিন",
    group: "গ্রুপ",
    terms: "পরিশোধের সময় (দিন)",
    bin: "BIN",
    withBalanceOnly: "শুধু বাকি আছে এমন",
    txnRef: "ট্রানজেকশন আইডি",
    txnRefHint: "বিকাশ, নগদ, রকেট, উপায় ও কার্ডের জন্য দরকার।",
    emptyCustomers: "এখনও কোনো ক্রেতা নেই",
    emptySuppliers: "এখনও কোনো সরবরাহকারী নেই",
    ledgerTypes: {
      opening: "শুরুর বাকি",
      sale: "বিক্রি",
      sale_return: "ফেরত",
      purchase: "ক্রয়",
      purchase_return: "ফেরত",
      payment: "পরিশোধ",
      adjustment: "সমন্বয়",
    },
  },
  pos: {
    extras: "কাস্টমার, ছাড় ও ভাউচার",
    title: "বিক্রয় কাউন্টার",
    scanOrSearch: "বারকোড স্ক্যান করুন বা খুঁজুন (F2)",
    cart: "কার্ট",
    emptyCart: "পণ্য যোগ করতে স্ক্যান করুন বা খুঁজুন",
    customer: "ক্রেতা",
    walkIn: "সাধারণ ক্রেতা",
    findCustomer: "নাম বা ফোন দিয়ে খুঁজুন",
    newCustomer: "নতুন ক্রেতা",
    subtotal: "উপমোট",
    discount: "ছাড়",
    billDiscount: "বিলে ছাড়",
    lineDiscount: "পণ্যে ছাড়",
    vat: "ভ্যাট",
    sd: "এসডি",
    rounding: "রাউন্ডিং",
    total: "মোট",
    pay: "পেমেন্ট (F9)",
    payTitle: "পেমেন্ট নিন",
    addPayment: "আরেকটি পেমেন্ট যোগ করুন",
    received: "পাওয়া গেছে",
    change: "ফেরত",
    due: "বাকি",
    complete: "বিক্রি সম্পন্ন করুন",
    hold: "রেখে দিন",
    held: "রেখে দেওয়া বিক্রি",
    resume: "আবার শুরু",
    clear: "মুছুন",
    registerClosed: "বিক্রি শুরু করতে ক্যাশ খুলুন",
    openRegister: "ক্যাশ খুলুন",
    openingFloat: "এখন ড্রয়ারে নগদ",
    closeRegister: "ক্যাশ বন্ধ করুন",
    countedCash: "গোনা নগদ",
    expected: "থাকার কথা",
    variance: "পার্থক্য",
    cashIn: "নগদ জমা",
    cashOut: "নগদ উত্তোলন",
    saleComplete: "বিক্রি সম্পন্ন",
    newSale: "নতুন বিক্রি",
    printReceipt: "রসিদ প্রিন্ট",
    percent: "%",
    amountTk: "৳",
    priceChanged: "দাম পরিবর্তিত",
    outOfStock: "স্টকে আছে মাত্র {qty}",
    shift: "শিফট",
    salesInShift: "{count}টি বিক্রি",
    holdLabel: "এই কার্টের নাম",
  },
  sales: {
    title: "বিক্রি",
    subtitle: "ইনভয়েস, ফেরত ও বাতিল।",
    number: "ইনভয়েস",
    customer: "ক্রেতা",
    paid: "পরিশোধিত",
    due: "বাকি",
    completed: "সম্পন্ন",
    void: "বাতিল",
    flagged: "স্টক যাচাই করুন",
    items: "পণ্য",
    payments: "পেমেন্ট",
    return: "পণ্য ফেরত",
    returnTitle: "পণ্য ফেরত",
    returnQty: "ফেরত",
    refundTo: "টাকা ফেরত দেবেন",
    reduceDue: "ক্রেতার বাকি থেকে কাটুন",
    voidSale: "বিক্রি বাতিল",
    voidHint: "স্টক, পেমেন্ট ও বাকি ফিরিয়ে নেওয়া হবে। ভুল করে করা বিক্রির জন্য এটি ব্যবহার করুন।",
    returns: "ফেরত",
    empty: "এই সময়ে কোনো বিক্রি নেই",
  },
  money: {
    accounts: "ক্যাশ ও অ্যাকাউন্ট",
    accountsSubtitle: "ক্যাশ ড্রয়ার, বিকাশ, নগদ ও ব্যাংক অ্যাকাউন্ট।",
    addAccount: "অ্যাকাউন্ট যোগ করুন",
    kind: "ধরন",
    kinds: {
      cash: "নগদ",
      bkash: "বিকাশ",
      nagad: "নগদ (MFS)",
      rocket: "রকেট",
      upay: "উপায়",
      card: "কার্ড",
      bank: "ব্যাংক",
      courier: "কুরিয়ার (পাওনা)",
    },
    accountName: "অ্যাকাউন্টের নাম",
    accountNumber: "নম্বর",
    openingBalance: "বর্তমান ব্যালেন্স",
    transfer: "স্থানান্তর",
    transferTitle: "এক অ্যাকাউন্ট থেকে আরেকটিতে টাকা পাঠান",
    fromAccount: "থেকে",
    toAccount: "তে",
    fee: "চার্জ",
    ownerMoney: "মালিকের টাকা",
    capital: "টাকা দিন",
    draw: "টাকা নিন",
    cashBook: "ক্যাশ বই",
    opening: "শুরুর ব্যালেন্স",
    inflow: "জমা",
    outflow: "খরচ",
    closing: "শেষ ব্যালেন্স",
    reconciled: "মিলানো হয়েছে",
    paymentTypes: {
      sale: "বিক্রি",
      sale_refund: "ফেরত",
      due_collection: "বাকি আদায়",
      purchase: "ক্রয়",
      purchase_refund: "সরবরাহকারীর ফেরত",
      supplier_payment: "সরবরাহকারীকে পরিশোধ",
      expense: "খরচ",
      income: "আয়",
      transfer: "স্থানান্তর",
      transfer_fee: "স্থানান্তর চার্জ",
      owner_capital: "মালিক দিলেন",
      owner_draw: "মালিক নিলেন",
      opening: "শুরুর ব্যালেন্স",
      cash_in: "নগদ জমা",
      cash_out: "নগদ উত্তোলন",
    },
  },
  expenses: {
    title: "খরচ",
    subtitle: "ভাড়া, বিল, বেতন ও অন্যান্য খরচ।",
    add: "খরচ যোগ করুন",
    category: "খাত",
    paidFrom: "যেখান থেকে দেওয়া",
    empty: "এই সময়ে কোনো খরচ নেই",
    voidTitle: "খরচ বাতিল",
  },
  receipt: {
    invoice: "ইনভয়েস",
    date: "তারিখ",
    cashier: "বিক্রেতা",
    item: "পণ্য",
    rate: "দর",
    thankYou: "আমাদের কাছ থেকে কেনার জন্য ধন্যবাদ",
    changeGiven: "ফেরত",
    paidBy: "পরিশোধ",
    vatReg: "BIN",
  },
  settings: {
    title: "সেটিংস",
    subtitle: "ব্যবসার তথ্য, ভ্যাট ও বিক্রয় কাউন্টারের নিয়ম।",
    business: "ব্যবসা",
    vat: "ভ্যাট",
    vatEnabled: "এই ব্যবসা ভ্যাট নিবন্ধিত",
    vatHint: "মূসক ৬.৩ ইনভয়েস প্রিন্ট ও ভ্যাট রেজিস্টার রাখা হবে।",
    pricesIncludeVat: "বিক্রয়মূল্যে ভ্যাট ধরা আছে",
    pos: "বিক্রয় কাউন্টার",
    cashRounding: "বিল রাউন্ড করুন",
    roundNone: "রাউন্ডিং নেই",
    roundHalf: "নিকটতম ৳০.৫০",
    roundOne: "নিকটতম ৳১",
    allowNegativeStock: "স্টক শূন্য দেখালেও বিক্রি করতে দিন",
    allowNegativeStockHint: "পরের মাল এলে ঘাটতি সমন্বয় হবে।",
    discountLimit: "ক্যাশিয়ারের ছাড়ের সীমা (%)",
    receiptNote: "রসিদের নিচের লেখা",
    receiptNoteHint: "যেমন আপনার পণ্য ফেরতের নিয়ম।",
    fiscalYearStart: "অর্থবছর শুরু",
    numbers: "সংখ্যা",
    digitsBangla: "বাংলা অঙ্ক (১২৩)",
    digitsLatin: "ইংরেজি অঙ্ক (123)",
    saved: "সেটিংস সংরক্ষিত হয়েছে",
    onlineOrders: "অনলাইন অর্ডার",
    orderSms: "অর্ডার কনফার্ম, পাঠানো, পৌঁছানো বা বাতিল হলে ক্রেতাকে SMS পাঠান",
    orderSmsHint: "আপনার SMS ক্রেডিট খরচ হবে। টেস্ট মোডের অর্ডারে SMS যায় না।",
  },
  reports: {
    title: "রিপোর্ট",
    subtitle: "বিক্রি, লাভ, পেমেন্ট ও স্টক।",
    sales: "বিক্রি",
    payments: "পেমেন্ট",
    balance: "স্থিতিপত্র",
    trial: "রেওয়ামিল",
    ledger: "খতিয়ান",
    pnl: "লাভ-ক্ষতি",
    stock: "স্টক",
    groupBy: "যেভাবে দেখাবে",
    groups: {
      day: "দিন",
      item: "পণ্য",
      category: "ক্যাটাগরি",
      cashier: "ক্যাশিয়ার",
      customer: "ক্রেতা",
    },
    invoices: "ইনভয়েস",
    gross: "মোট",
    net: "নিট",
    profit: "লাভ",
    margin: "মার্জিন",
    exportCsv: "এক্সপোর্ট (এক্সেল)",
    range: "সময়কাল",
    thisMonth: "এই মাস",
    lastMonth: "গত মাস",
    custom: "নিজে বেছে নিন",
    salesLine: "বিক্রি",
    returnsLine: "ফেরত",
    netSales: "নিট বিক্রি",
    cogs: "বিক্রিত পণ্যের ক্রয়মূল্য",
    grossProfit: "মোট লাভ",
    inventoryLoss: "স্টকের ক্ষতি",
    expenses: "খরচ",
    paymentFees: "পেমেন্ট চার্জ",
    otherIncome: "অন্যান্য আয়",
    netProfit: "নিট লাভ",
    valuation: "স্টকের মূল্য",
    slowMoving: "{days} দিনে বিক্রি হয়নি",
    atCost: "ক্রয়মূল্যে",
    atRetail: "বিক্রয়মূল্যে",
    lastSold: "শেষ বিক্রি",
    never: "কখনো না",
    count: "সংখ্যা",
    walkIn: "সাধারণ ক্রেতা",
    reorder: "পুনঃঅর্ডার",
  },
  reorder: {
    hint: "যে পণ্যগুলো পুনঃঅর্ডারের সীমায় বা তার নিচে, এবং বিক্রি চালাতে কতটা অর্ডার দিতে হবে। গত ৩০ দিনের বিক্রির ভিত্তিতে।",
    leadTime: "ডেলিভারির সময়",
    leadOption: "{n} দিনে ডেলিভারি",
    cover: "কত দিনের জন্য অর্ডার",
    coverOption: "{n} দিনের জন্য",
    supplier: "সরবরাহকারী",
    noSupplier: "কখনো কেনা হয়নি",
    onHand: "মজুদ",
    lasts: "চলবে",
    order: "অর্ডার",
    estimated: "আনুমানিক খরচ",
    days: "{n} দিন",
    outNow: "এখনই শেষ",
    empty: "এখন কিছু পুনঃঅর্ডার করার দরকার নেই।",
  },
  vat: {
    title: "ভ্যাট",
    subtitle: "এনবিআর রেজিস্টার ও ইনভয়েস।",
    salesRegister: "বিক্রয় হিসাব পুস্তক (মূসক ৬.২)",
    purchaseRegister: "ক্রয় হিসাব পুস্তক (মূসক ৬.১)",
    creditNotes: "ক্রেডিট নোট",
    value: "মূল্য",
    sd: "সম্পূরক শুল্ক",
    vat: "মূসক",
    buyer: "ক্রেতা",
    seller: "বিক্রেতা",
    bin: "বিআইএন",
    notRegistered: "ভ্যাট রেজিস্টার ব্যবহার করতে সেটিংসে BIN দিয়ে ভ্যাট চালু করুন।",
    mushak63: "মূসক ৬.৩ কর চালানপত্র",
    taxInvoice: "কর চালানপত্র",
    rule: "[বিধি ৪০ এর উপ-বিধি (১) এর দফা (গ) ও দফা (চ) দ্রষ্টব্য]",
    issuer: "নিবন্ধিত ব্যক্তির নাম",
    issuerBin: "নিবন্ধিত ব্যক্তির বিআইএন",
    issuerAddress: "চালানপত্র ইস্যুর ঠিকানা",
    buyerName: "ক্রেতার নাম",
    buyerBin: "ক্রেতার বিআইএন",
    destination: "সরবরাহের গন্তব্যস্থল",
    vehicle: "যানবাহনের প্রকৃতি ও নম্বর",
    challanNo: "চালানপত্র নম্বর",
    issueDate: "ইস্যুর তারিখ",
    issueTime: "ইস্যুর সময়",
    sl: "ক্রমিক",
    description: "পণ্য বা সেবার বর্ণনা",
    unitOfSupply: "সরবরাহের একক",
    quantity: "পরিমাণ",
    unitPrice: "একক মূল্য (টাকা)",
    totalPrice: "মোট মূল্য (টাকা)",
    sdRate: "সম্পূরক শুল্কের হার",
    sdAmount: "সম্পূরক শুল্ক (টাকা)",
    vatRate: "মূসকের হার",
    vatAmount: "মূসক (টাকা)",
    totalWithTaxes: "সকল শুল্ক ও করসহ মূল্য (টাকা)",
    signature: "প্রতিষ্ঠান কর্তৃপক্ষের দায়িত্বপ্রাপ্ত ব্যক্তির স্বাক্ষর",
    printMushak: "মূসক ৬.৩ প্রিন্ট",
  },
  team: {
    title: "টিম",
    subtitle: "কারা এই ব্যবসা ব্যবহার করবেন এবং কী করতে পারবেন।",
    invite: "কর্মী আমন্ত্রণ",
    inviteHint: "তাঁরা একটি ইমেইল পাবেন এবং এই Gmail দিয়ে সাইন ইন করলেই যোগ হবেন।",
    inviteEmailHint: "শুধু Gmail, যেমন name@gmail.com",
    pending: "আমন্ত্রিত",
    expires: "আমন্ত্রণের মেয়াদ {when}",
    revoke: "আমন্ত্রণ বাতিল",
    remove: "সরিয়ে দিন",
    allBranches: "সব শাখা",
    branches: "শাখা",
    you: "আপনি",
  },
  branches: {
    title: "শাখা",
    add: "শাখা যোগ করুন",
    code: "সংক্ষিপ্ত কোড",
    codeHint: "২–৬ অক্ষর, ইনভয়েস নম্বরে ছাপা হয়। পরে বদলানো যাবে না।",
    close: "শাখা বন্ধ করুন",
    main: "প্রধান",
  },
  billing: {
    title: "প্ল্যান ও বিলিং",
    subtitle: "আপনার প্ল্যান, ব্যবহার, SMS ক্রেডিট ও ইনভয়েস।",
    current: "বর্তমান প্ল্যান",
    renews: "{date} পর্যন্ত পরিশোধিত",
    grace: "পেমেন্ট বকেয়া। পেইড সুবিধা রাখতে {date}-এর মধ্যে নবায়ন করুন।",
    lapsed: "আপনার প্ল্যান শেষ হয়েছে। নবায়ন না করা পর্যন্ত ফ্রি সীমা প্রযোজ্য।",
    usage: "ব্যবহার",
    unlimited: "সীমাহীন",
    of: "{limit}-এর মধ্যে {used}",
    users: "ব্যবহারকারী",
    branches: "শাখা",
    items: "পণ্য",
    monthly: "মাসিক",
    yearly: "বার্ষিক",
    perMonth: "/মাস",
    perYear: "/বছর",
    choose: "{plan} নিন",
    renew: "নবায়ন করুন",
    notOnSale: "দাম এখনও নির্ধারিত হয়নি",
    contactSales: "যোগাযোগ করুন",
    smsCredits: "SMS ক্রেডিট",
    buyCredits: "{credits} ক্রেডিট কিনুন",
    invoices: "ইনভয়েস",
    invoice: "ইনভয়েস",
    email: "রসিদের জন্য ইমেইল",
    receiptTo: "রসিদ যাবে {email} ঠিকানায়।",
    phone: "পেমেন্টের জন্য মোবাইল নম্বর",
    phoneHint: "পেমেন্ট পাতায় এটি লাগে; বিকাশ ও নগদ নিশ্চিতকরণ পাঠাতে পারে।",
    payWith: "আপনি নিরাপদ পেমেন্ট পাতায় বিকাশ, নগদ, রকেট বা অন্য মাধ্যমে পরিশোধ করবেন।",
    paid: "পেমেন্ট পাওয়া গেছে। ধন্যবাদ!",
    failed: "পেমেন্ট সম্পন্ন হয়নি। কোনো টাকা কাটা হয়নি।",
    cancelled: "পেমেন্ট বাতিল করা হয়েছে।",
    pending: "আপনার পেমেন্ট যাচাই করা হচ্ছে। নিশ্চিত হলেই প্ল্যান বা ক্রেডিট যোগ হয়ে যাবে।",
    offline: "অনলাইন পেমেন্ট এখন চালু নেই। সাপোর্টে যোগাযোগ করুন।",
    features: {
      vat: "ভ্যাট ইনভয়েস (মূসক ৬.৩)",
      offline: "অফলাইনে বিক্রি",
      multi_branch: "একাধিক শাখা",
      custom_domain: "নিজস্ব ওয়েবসাইট ডোমেইন",
      api: "ডেভেলপার API",
      couriers: "কুরিয়ার বুকিং",
      advanced_reports: "উন্নত রিপোর্ট",
    },
    upgrade: "আপগ্রেড",
    billedTo: "বিল প্রাপক",
    issuedBy: "প্রদানকারী",
    refunded: "ফেরত",
  },
  sms: {
    reminders: "বাকির রিমাইন্ডার পাঠান",
    remindersHint: "যাদের বাকি ও ফোন নম্বর আছে তারা প্রত্যেকে SMS পাবেন।",
    template: "মেসেজ",
    placeholders: "{name}, {amount} ও {shop} ব্যবহার করুন।",
    preview: "নমুনা",
    cost: "{count}টি মেসেজ · প্রায় {credits} ক্রেডিট",
    balance: "অবশিষ্ট ক্রেডিট: {balance}",
    send: "পাঠান",
    sent: "{count}টি মেসেজ পাঠানোর জন্য রাখা হয়েছে",
    receipt: "SMS রসিদ",
    noCredits: "যথেষ্ট SMS ক্রেডিট নেই",
    status: {
      queued: "অপেক্ষমাণ",
      sent: "পাঠানো হয়েছে",
      failed: "ব্যর্থ",
    },
  },
  import: {
    title: "ইমপোর্ট",
    items: "পণ্য ইমপোর্ট",
    customers: "ক্রেতা ইমপোর্ট",
    suppliers: "সরবরাহকারী ইমপোর্ট",
    choose: "এক্সেল (.xlsx) বা CSV ফাইল বেছে নিন",
    template: "টেমপ্লেট ডাউনলোড",
    map: "কলাম মিলিয়ে নিন",
    skip: "ইমপোর্ট করবেন না",
    rows: "{count}টি সারি",
    errors: "{count}টি সারি ঠিক করা দরকার",
    run: "{count}টি সারি ইমপোর্ট করুন",
    done: "{count}টি সারি ইমপোর্ট হয়েছে",
    row: "সারি {n}",
    fields: {
      nameEn: "নাম (ইংরেজি)",
      nameBn: "নাম (বাংলা)",
      category: "ক্যাটাগরি",
      brand: "ব্র্যান্ড",
      baseUnit: "একক",
      salePrice: "বিক্রয়মূল্য",
      mrp: "এমআরপি",
      sku: "এসকেইউ",
      barcode: "বারকোড",
      vatRate: "ভ্যাট %",
      reorderLevel: "কম স্টকের সতর্কতা",
      openingQty: "শুরুর পরিমাণ",
      openingCost: "প্রতি এককের ক্রয়মূল্য",
      batchNo: "ব্যাচ",
      expiryDate: "মেয়াদ শেষের তারিখ",
      name: "নাম",
      phone: "ফোন",
      address: "ঠিকানা",
      openingBalance: "শুরুর বাকি",
    },
  },
  starter: {
    title: "ক্যাটালগ থেকে যোগ করুন",
    subtitle: "সাধারণ পণ্য বেছে নিন এবং নিজের দাম দিন।",
    empty: "আপনার ব্যবসার ধরনের জন্য এখনও কোনো ক্যাটালগ নেই।",
    add: "{count}টি পণ্য যোগ করুন",
  },
  admin: {
    title: "জিটা অ্যাডমিন",
    metrics: "সারসংক্ষেপ",
    tenants: "ব্যবসাসমূহ",
    pricing: "মূল্য",
    catalog: "স্টার্টার ক্যাটালগ",
    audit: "অডিট লগ",
    errors: "ত্রুটি",
    noErrors: "গত ৭ দিনে কোনো ত্রুটি নেই।",
    errorCount: "{count} বার · {tenants}টি ব্যবসা",
    signups: "গত ৩০ দিনে নতুন",
    paying: "পেইড",
    revenue: "আয়, ৩০ দিন",
    smsSent: "পাঠানো SMS, ৩০ দিন",
    suspended: "স্থগিত",
    suspend: "স্থগিত করুন",
    reactivate: "পুনরায় চালু করুন",
    setPlan: "প্ল্যান নির্ধারণ",
    grantSms: "SMS ক্রেডিট দিন",
    reason: "কারণ (অডিট লগে থাকবে)",
    periodEnd: "পরিশোধিত পর্যন্ত",
    owner: "মালিক",
    source: "ডেটার উৎস",
    uploadCatalog: "ক্যাটালগ ফাইল আপলোড",
    replaceCatalog: "{pack} ক্যাটালগ {count}টি সারি দিয়ে প্রতিস্থাপন করুন",
    readOnly: "সাপোর্ট অ্যাক্সেস শুধু দেখার জন্য।",
    staff: "স্টাফ",
    signins: "সাইন-ইন",
    support: "সাপোর্ট ভিজিট",
    openAdmin: "প্ল্যাটফর্ম অ্যাডমিন",
    stepUpTitle: "নিশ্চিত করুন এটি আপনি",
    stepUpHint:
      "{email}-এ পাঠানো কোড দিলে অ্যাডমিন খুলবে। সর্বোচ্চ ৮ ঘণ্টা খোলা থাকবে, ৩০ মিনিট ব্যবহার না হলে বন্ধ হবে।",
    stepUpSend: "আমাকে কোড ইমেইল করুন",
    stepUpVerify: "অ্যাডমিন খুলুন",
    lock: "অ্যাডমিন বন্ধ করুন",
    staffEmail: "Gmail ঠিকানা",
    staffEmailHint: "তাকে অন্তত একবার Zeeta-তে সাইন ইন করতে হবে।",
    role: "ভূমিকা",
    roleAdmin: "অ্যাডমিন (পূর্ণ নিয়ন্ত্রণ)",
    roleSupport: "সাপোর্ট (শুধু দেখা)",
    addStaff: "স্টাফে যোগ করুন",
    removeStaff: "স্টাফ থেকে সরান",
    removeConfirm: "{name}-কে অ্যাডমিন স্টাফ থেকে সরাবেন? তার অ্যাডমিন অ্যাক্সেস এখনই বন্ধ হবে।",
    lastUsed: "শেষ অ্যাডমিন ব্যবহার",
    you: "আপনি",
    suspicious: "গত এক ঘণ্টায় এই ঠিকানাগুলো থেকে অনেকবার ভুল সাইন-ইন",
    failures: "{n} বার ভুল",
    search: "খুঁজুন",
    eventsSearch: "ইমেইল, ফোন বা IP দিয়ে খুঁজুন",
    eventType: "ঘটনা",
    allEvents: "সব ঘটনা",
    who: "কে",
    events: {
      otp_requested: "কোড চাওয়া হয়েছে",
      otp_failed: "ভুল কোড",
      signin: "সাইন ইন",
      signout: "সাইন আউট",
      session_revoked: "ডিভাইস সাইন আউট",
      user_created: "অ্যাকাউন্ট তৈরি",
      password_set: "পাসওয়ার্ড সেট",
      password_failed: "ভুল পাসওয়ার্ড",
      google_signin: "Google দিয়ে সাইন ইন",
      email_changed: "ইমেইল বদল",
      phone_verified: "ফোন যাচাই",
      admin_step_up: "অ্যাডমিন খোলা",
      admin_step_up_failed: "ভুল অ্যাডমিন কোড",
      admin_pin_unlock: "পিন দিয়ে অ্যাডমিন খোলা",
      admin_pin_failed: "ভুল অ্যাডমিন পিন",
      admin_pin_set: "অ্যাডমিন পিন সেট",
      admin_pin_removed: "অ্যাডমিন পিন মুছা",
    },
    business: "ব্যবসা",
    reasonShort: "কারণ",
    until: "পর্যন্ত",
    modeRead: "শুধু দেখা",
    modeWrite: "পরিবর্তন করতে পারবে",
    ended: "শেষ",
    endedByBusiness: "ব্যবসা বন্ধ করেছে",
    openBusiness: "খুলুন",
    endVisit: "শেষ করুন",
    supportTitle: "সাপোর্ট হিসেবে খুলুন",
    supportHint:
      "মালিক যেভাবে দেখেন সেভাবে এই ব্যবসা দেখুন, তাকে সাহায্য করতে। মালিককে ইমেইল করা হবে, ভিজিট নিজে থেকে শেষ হবে, এবং সবকিছু লগে থাকবে।",
    supportReason: "কেন (মালিক এটি দেখবেন)",
    duration: "কতক্ষণ",
    minutes: "{n} মিনিট",
    mode: "অ্যাক্সেস",
    startVisit: "ব্যবসা খুলুন",
    tempPassword: "অস্থায়ী পাসওয়ার্ড",
    tempIssued: "{email}-এর অস্থায়ী পাসওয়ার্ড। এটি শুধু এখনই দেখানো হচ্ছে:",
    tempHint: "২৪ ঘণ্টার মধ্যে একবার কাজ করবে; এটি দিয়ে সাইন ইন করার পর নিজের পাসওয়ার্ড বেছে নিতে হবে।",
    account: "আমার অ্যাকাউন্ট",
    lockHint: "এই ব্রাউজারে অ্যাডমিন বন্ধ করে। আপনি Zeeta-তে সাইন ইন থাকবেন; আবার খুলতে নতুন ইমেইল কোড লাগবে।",
    groupPlatform: "প্ল্যাটফর্ম",
    businessTypes: "ব্যবসার ধরন",
    announcements: "ঘোষণা",
    maintenance: "রক্ষণাবেক্ষণ",
    securitySettings: "নিরাপত্তা ও সাইন-আপ",
    ai: "এআই",
    barcodes: "বারকোড লাইব্রেরি",
    groupSettings: "সেটিংস",
    groupSecurity: "নিরাপত্তা",
    groupYou: "আপনি",
    modeFull: "পূর্ণ অ্যাক্সেস (মালিকের মতো)",
    users: "ব্যবহারকারী",
    billing: "বিলিং",
  },
  pwa: {
    updateReady: "জিটার নতুন সংস্করণ প্রস্তুত।",
    reload: "রিলোড করুন",
  },
  offline: {
    online: "অনলাইন",
    offline: "অফলাইন",
    pending: "{count}টি বিক্রি সিঙ্কের অপেক্ষায়",
    syncing: "সিঙ্ক হচ্ছে…",
    syncNow: "এখন সিঙ্ক করুন",
    syncFailed: "{count}টি বিক্রি যাচাই করা দরকার",
    snapshotAge: "পণ্যের তালিকা হালনাগাদ {when}",
    refresh: "পণ্যের তালিকা হালনাগাদ করুন",
    provisional: "অস্থায়ী নং",
    signOutBlocked: "কিছু বিক্রি এখনও সিঙ্ক হয়নি। আগে ইন্টারনেটে যুক্ত হন।",
    offlineSale: "অফলাইনে সংরক্ষিত। নিজে থেকেই সিঙ্ক হবে।",
  },
  account: {
    title: "অ্যাকাউন্ট ও নিরাপত্তা",
    subtitle: "আপনি কীভাবে Zeeta-তে সাইন ইন করবেন।",
    emailTitle: "Gmail",
    emailHint: "এই ঠিকানা দিয়ে সাইন ইন করবেন; আমন্ত্রণ ও রসিদ এখানে আসবে।",
    addEmailNow: "আপনার Gmail যোগ করুন। ফোন নম্বর দিয়ে সাইন ইন বন্ধ হয়ে যাচ্ছে।",
    changeEmail: "অন্য Gmail-এ বদলান",
    passwordTitle: "পাসওয়ার্ড",
    passwordHint: "ঐচ্ছিক। কোডের বদলে Gmail ও পাসওয়ার্ড দিয়ে সাইন ইন করতে পারবেন।",
    passwordSaved: "পাসওয়ার্ড সংরক্ষিত। অন্য ডিভাইসগুলো থেকে সাইন আউট করা হয়েছে।",
    currentPassword: "বর্তমান পাসওয়ার্ড",
    newPassword: "নতুন পাসওয়ার্ড",
    confirmPassword: "আবার লিখুন",
    passwordRules: "অন্তত ১০ অক্ষর। ইমেইল বা সহজ পাসওয়ার্ড নয়।",
    passwordMismatch: "দুটি পাসওয়ার্ড মেলেনি",
    setPassword: "পাসওয়ার্ড দিন",
    changePassword: "পাসওয়ার্ড বদলান",
    reauth: 'নিরাপত্তার জন্য বর্তমান পাসওয়ার্ড দিন, অথবা নিচের "বর্তমান পাসওয়ার্ড ভুলে গেছেন?" থেকে ইমেইল কোড নিন।',
    forgotCurrent: "বর্তমান পাসওয়ার্ড ভুলে গেছেন?",
    phoneTitle: "মোবাইল নম্বর",
    phoneHint: "ঐচ্ছিক। যাচাই করা নম্বরে SMS সতর্কবার্তা যেতে পারে।",
    changePhone: "অন্য নম্বর দিন",
    verifyPhone: "কোড পাঠান",
    verified: "যাচাই করা",
    notVerified: "যাচাই হয়নি",
    banner: "অ্যাকাউন্ট ঠিক রাখতে আপনার Gmail যোগ করুন।",
    bannerAction: "Gmail যোগ করুন",
    forgotHint: 'ভুলে গেছেন? নিচের "বর্তমান পাসওয়ার্ড ভুলে গেছেন?" ব্যবহার করুন।',
    mustChangeTitle: "নিজের পাসওয়ার্ড বেছে নিন",
    mustChangeHint:
      "আপনি অস্থায়ী পাসওয়ার্ড দিয়ে সাইন ইন করেছেন। এগোনোর আগে এমন পাসওয়ার্ড দিন যা শুধু আপনি জানেন।",
  },
  sessions: {
    title: "সাইন-ইন করা ডিভাইস",
    subtitle: "যে ডিভাইস চেনেন না সেগুলো থেকে সাইন আউট করুন।",
    thisDevice: "এই ডিভাইস",
    trusted: "মনে রাখা হয়েছে",
    lastActive: "সর্বশেষ সক্রিয় {when}",
    signedIn: "সাইন ইন {when}",
    revoke: "সাইন আউট",
    unknownDevice: "অজানা ডিভাইস",
  },
  legal: {
    productOf: "{company}-এর একটি পণ্য",
    terms: "শর্তাবলি",
    privacy: "গোপনীয়তা নীতি",
    nav: "আইনি তথ্য",
    agreePrefix: "এগিয়ে গেলে আপনি জিটার",
    and: "ও",
    agreeSuffix: "মেনে নিচ্ছেন।",
  },
  orders: {
    markReturned: "পার্সেল ফেরত এসেছে",
    returnedHint: "সব পণ্য স্টকে ফেরত যাবে এবং ডেলিভারি চার্জসহ এই অর্ডারে গ্রাহকের পাওনা মুছে যাবে।",
    returnReasonPlaceholder: "যেমন গ্রাহক নেননি, ভুল ঠিকানা",
    title: "অনলাইন অর্ডার",
    subtitle: "আপনার ওয়েবসাইট ও অ্যাপ থেকে আসা অর্ডার। পাঠানো বা বাতিল না হওয়া পর্যন্ত স্টক আটকে রাখা হয়।",
    testMode: "টেস্ট অর্ডার দেখুন",
    testModeHint: "আপনি টেস্ট মোডের অর্ডার দেখছেন। এগুলো আপনার আসল স্টক বা হিসাবে কোনো প্রভাব ফেলে না।",
    testOrder: "টেস্ট অর্ডার",
    search: "অর্ডার নম্বর, ফোন বা নাম",
    empty: "এখানে কোনো অর্ডার নেই",
    emptyHint: "আপনার API কী বা ওয়েবসাইট থেকে দেওয়া অর্ডার এখানে আসবে।",
    number: "অর্ডার",
    customer: "ক্রেতা",
    district: "জেলা",
    placed: "অর্ডারের সময়",
    prepaid: "অগ্রিম পরিশোধিত",
    cod: "ক্যাশ অন ডেলিভারি",
    status: {
      pending: "নতুন",
      confirmed: "কনফার্মড",
      packed: "প্যাক করা",
      shipped: "পাঠানো হয়েছে",
      delivered: "পৌঁছে গেছে",
      cancelled: "বাতিল",
      returned: "ফেরত এসেছে",
      all: "সব",
    },
    channel: { api: "API", storefront: "ওয়েবসাইট", manual: "নিজে তৈরি" },
    confirm: "অর্ডার কনফার্ম করুন",
    pack: "প্যাক হয়েছে",
    ship: "পাঠানো হয়েছে",
    deliver: "পৌঁছে গেছে",
    cancel: "অর্ডার বাতিল",
    items: "পণ্য",
    subtotal: "ভ্যাটের আগের মূল্য",
    sd: "সম্পূরক শুল্ক",
    vat: "ভ্যাট",
    deliveryCharge: "ডেলিভারি চার্জ",
    paid: "পরিশোধিত",
    toCollect: "আদায় বাকি",
    statusTitle: "অবস্থা",
    reason: "কারণ",
    viewSale: "বিক্রিটি দেখুন",
    shipTo: "যেখানে পৌঁছাবে",
    externalRef: "তাদের রেফারেন্স",
    shipHint: "পণ্যগুলো এখন স্টক থেকে বাদ যাবে এবং ক্রেতার নামে বিক্রি লেখা হবে।",
    receivedIn: "টাকা যেখানে এসেছে",
    txnRef: "ট্রানজেকশন আইডি",
    collectCod: "ডেলিভারিতে {amount} পেয়েছি",
    leaveDue: "টাকাটা ক্রেতার বাকি হিসেবে থাকবে।",
    alreadyPaid: "এই অর্ডারের টাকা পরিশোধ হয়ে গেছে।",
    cancelHint: "আটকে রাখা স্টক ছেড়ে দেওয়া হবে। অর্ডার SMS চালু থাকলে ক্রেতাকে জানানো হবে।",
  },
  accounts: {
    asAt: "{date} তারিখ পর্যন্ত",
    balanced: "মিলেছে",
    notBalanced: "মেলেনি — সাপোর্টে যোগাযোগ করুন",
    code: "কোড",
    debit: "ডেবিট",
    credit: "ক্রেডিট",
    balance: "জের",
    account: "হিসাব",
    entry: "লেনদেন",
    opening: "প্রারম্ভিক জের",
    closing: "সমাপনী জের",
    assets: "ব্যবসার সম্পদ",
    liabilities: "দেনা",
    equity: "মালিকের অংশ",
    totalAssets: "মোট সম্পদ",
    totalLiabilitiesEquity: "মোট দেনা ও মালিকের অংশ",
    truncated: "প্রথম ২,০০০টি লেনদেন দেখানো হচ্ছে। বাকিগুলো দেখতে ছোট সময়কাল বাছুন।",
    refs: {
      sale: "বিক্রয়",
      sale_return: "বিক্রয় ফেরত",
      sale_void: "বিক্রয় বাতিল",
      purchase: "ক্রয়",
      purchase_return: "ক্রয় ফেরত",
      payment: "পেমেন্ট",
      expense: "খরচ",
      expense_void: "খরচ বাতিল",
      transfer: "স্থানান্তর",
      order: "অনলাইন অর্ডার",
      order_return: "ফেরত আসা অর্ডার",
      vat_return: "ভ্যাট রিটার্ন দাখিল",
      vat_payment: "ভ্যাট জমা",
    },
  },
  vatReturn: {
    title: "মাসিক রিটার্ন (মূসক ৯.১)",
    period: "কর মেয়াদ",
    file: "রিটার্ন দাখিল",
    fileTitle: "{period} মেয়াদের রিটার্ন দাখিল",
    fileHint:
      "এই হিসাব স্থির হবে এবং এই মেয়াদের ভ্যাট ও সম্পূরক শুল্ক পরিশোধযোগ্য ভ্যাটে যাবে। একই হিসাব এনবিআর ই-ভ্যাট পোর্টালে দাখিল করুন।",
    submissionRef: "এনবিআর দাখিল নম্বর",
    submissionRefHint: "অনলাইনে দাখিলের পর ই-ভ্যাট পোর্টাল থেকে।",
    recordDeposit: "ট্রেজারি জমা লিখুন",
    paidFrom: "যে হিসাব থেকে পরিশোধ",
    challan: "চালান / ই-পেমেন্ট নং",
    filedOn: "{date} তারিখে দাখিল",
    notFiled: "এখনো দাখিল হয়নি",
    inProgress: "মাস চলছে",
    changed: "দাখিলের পর এই মাসের লেনদেন বদলেছে; সংশোধিত রিটার্ন লাগতে পারে।",
    note: "নোট",
    item: "বিবরণ",
    supplies: "বিক্রয় (উৎপাদ কর)",
    zeroOrExempt: "শূন্য হারবিশিষ্ট ও অব্যাহতিপ্রাপ্ত সরবরাহ",
    standard: "আদর্শ হার (১৫%)",
    reduced: "হ্রাসকৃত হার ({rate}%)",
    totalOutput: "মোট উৎপাদ কর",
    purchases: "ক্রয় (উপকরণ কর)",
    localPurchases: "রেয়াতযোগ্য স্থানীয় ক্রয়",
    totalInput: "মোট ক্রয় ও উপকরণ কর রেয়াত",
    adjustments: "সমন্বয়",
    debitNotes: "ডেবিট নোট (ক্রয় ফেরত): বৃদ্ধিকারী",
    creditNotes: "ক্রেডিট নোট (বিক্রয় ফেরত): হ্রাসকারী",
    net: "নিট কর",
    netVat: "নিট পরিশোধযোগ্য ভ্যাট",
    netSd: "নিট পরিশোধযোগ্য সম্পূরক শুল্ক",
    carriedForward: "পূর্ববর্তী মেয়াদ থেকে জের",
    toDeposit: "এই মেয়াদে জমা দিতে হবে",
    disclaimer:
      "আপনার বিক্রয়, ক্রয় ও ফেরত থেকে হিসাব করা। নোট নম্বর মূসক ৯.১ অনুযায়ী; দাখিলের আগে আপনার ভ্যাট পরামর্শকের সাথে মিলিয়ে নিন।",
  },
  storefront: {
    title: "অনলাইন শপ",
    subtitle: "আপনার নিজের ওয়েবসাইট, পণ্য ও স্টক সরাসরি Zeeta থেকে।",
    setupTitle: "আপনার অনলাইন শপ খুলুন",
    setupHint: "একটি ঠিকানা আর ডিজাইন বাছুন। পরে সবকিছু বদলানো যাবে, প্রকাশ না করা পর্যন্ত কেউ দেখবে না।",
    address: "শপের ঠিকানা",
    addressHint: "৩ থেকে ৪০টি ইংরেজি অক্ষর, সংখ্যা বা হাইফেন, যেমন rahim-store।",
    addressChangeHint: "ঠিকানা বদলালে আগে শেয়ার করা লিংক কাজ করবে না।",
    theme: "থিম",
    themes: {
      bazaar: "বাজার",
      boutique: "বুটিক",
      apothecary: "অ্যাপোথেকারি",
      catalog: "ক্যাটালগ",
    },
    themeHints: {
      bazaar: "সাহসী আর দ্রুত, জমজমাট বাজারের মতো। মুদি ও সাধারণ দোকানের জন্য।",
      boutique: "ম্যাগাজিনের মতো, বড় ছবি। পোশাক, ইলেকট্রনিক্স ও উপহারের জন্য।",
      apothecary: "শান্ত আর ভরসার। ফার্মেসি ও স্বাস্থ্যপণ্যের জন্য।",
      catalog: "শোরুম: পণ্য আর দাম, অনলাইন অর্ডার ছাড়া।",
    },
    create: "আমার শপ তৈরি করুন",
    live: "চালু",
    offline: "প্রকাশিত নয়",
    unpublished: "প্রকাশ না করা পরিবর্তন",
    saveDraft: "খসড়া সংরক্ষণ",
    saved: "সংরক্ষিত",
    publish: "প্রকাশ করুন",
    takeOffline: "বন্ধ করুন",
    preview: "প্রিভিউ",
    previewSaveHint: "পরিবর্তন দেখতে সংরক্ষণ করুন",
    mobile: "ফোনে দেখুন",
    desktop: "কম্পিউটারে দেখুন",
    reload: "প্রিভিউ রিলোড",
    tabs: {
      sections: "সেকশন",
      design: "ডিজাইন ও SEO",
      delivery: "ডেলিভারি ও চেকআউট",
      address: "ঠিকানা",
      stats: "ভিজিট ও বিক্রি",
    },
    sections: {
      announcement: "ঘোষণা বার",
      highlights: "বিশেষ সুবিধা",
      hero: "হিরো",
      categories: "ক্যাটাগরি টাইল",
      products: "পণ্যের তালিকা",
      banner: "ব্যানার",
      text: "লেখা",
      contact: "যোগাযোগ",
    },
    sources: {
      newest: "নতুন পণ্য",
      category: "একটি ক্যাটাগরি থেকে",
      manual: "বাছাই করা",
    },
    heroLayouts: {
      split: "লেখার পাশে ছবি",
      full: "লেখার পেছনে ছবি",
      text: "আপনার রঙের ওপর লেখা",
    },
    highlightsHint:
      "হিরোর নিচে চারটি পর্যন্ত ছোট প্রতিশ্রুতি। খালি রাখলে দোকান নিজেই দেখাবে ক্যাশ অন ডেলিভারি, ডেলিভারি চার্জ, ফ্রি ডেলিভারি আর আপনার ফোন নম্বর।",
    fields: {
      layout: "লেআউট",
      promise: "প্রতিশ্রুতি {n}",
      promiseBody: "নিচে ছোট একটি লাইন",
      text: "লেখা",
      heading: "শিরোনাম",
      subheading: "উপশিরোনাম",
      image: "ছবি",
      button: "বাটনের লেখা",
      buttonLink: "বাটনের লিংক",
      title: "শিরোনাম",
      body: "লেখা",
      categories: "ক্যাটাগরি",
      categoriesHint: "কোনোটি না বাছলে অনলাইনে পণ্য আছে এমন সব ক্যাটাগরি দেখাবে।",
      source: "দেখাবে",
      limit: "কয়টি",
      showPhone: "ফোন নম্বর দেখান",
      showAddress: "ঠিকানা দেখান",
      hours: "খোলার সময়",
    },
    link: "লিংক",
    linkHint: "শপের পাতা যেমন /products বা /c/…, অথবা পুরো https:// লিংক।",
    addSection: "সেকশন যোগ করুন",
    hide: "সেকশন লুকান",
    show: "সেকশন দেখান",
    moveUp: "উপরে নিন",
    moveDown: "নিচে নিন",
    searchItems: "যোগ করতে পণ্য খুঁজুন",
    pickedItem: "পণ্য {n}",
    bangla: "বাংলা",
    english: "ইংরেজি",
    color: "ব্র্যান্ডের রং",
    logo: "লোগো",
    tagline: "ট্যাগলাইন",
    defaultLanguage: "ক্রেতারা প্রথমে যে ভাষা দেখবেন",
    seoTitle: "সার্চ রেজাল্টে শিরোনাম",
    seoDescription: "সার্চ রেজাল্টে বিবরণ",
    footerNote: "ফুটারের লেখা",
    catalogHint: "শুধু ক্যাটালগ: ক্রেতারা পণ্য ও স্টক দেখবেন, অনলাইনে অর্ডার করতে পারবেন না।",
    branch: "যে শাখার স্টক বিক্রি হবে",
    branchHint: "অনলাইন অর্ডারের স্টক এই শাখা থেকে রিজার্ভ ও পাঠানো হবে।",
    mainBranch: "প্রধান শাখা",
    insideDhaka: "ঢাকার ভেতরে ডেলিভারি",
    outsideDhaka: "ঢাকার বাইরে ডেলিভারি",
    districtRates: "কিছু জেলার জন্য আলাদা চার্জ",
    district: "জেলা",
    freeDelivery: "বড় অর্ডারে ফ্রি ডেলিভারি",
    freeAbove: "ফ্রি ডেলিভারি শুরু",
    minOrder: "সর্বনিম্ন অর্ডার",
    minOrderHint: "০ মানে কোনো সীমা নেই।",
    verifyPhone: "কোড দিয়ে ক্রেতার ফোন যাচাই করুন",
    verifyPhoneHint: "ভুয়া ক্যাশ অন ডেলিভারি অর্ডার কমায়। প্রতিটি কোডে একটি SMS ক্রেডিট লাগে।",
    hideOutOfStock: "স্টক নেই এমন পণ্য লুকান",
    shopperAccounts: "ক্রেতারা সাইন ইন করে নিজেদের অর্ডার দেখতে পারবেন",
    shopperAccountsHint:
      "ফোনে কোড দিয়ে সাইন ইন (প্রতিটিতে একটি SMS ক্রেডিট); চেকআউটে আগের ঠিকানা আপনা থেকে বসে যাবে।",
    checkoutNote: "চেকআউট পাতার নোট",
    stats: {
      hint: "প্রতিটি ব্রাউজার দিনে একবার ভিজিটর হিসেবে গোনা হয়। সার্চ ইঞ্জিন ও আপনার প্রিভিউ গোনা হয় না।",
      period: "সময়কাল",
      lastDays: "গত {n} দিন",
      visitors: "ভিজিটর",
      views: "{n}টি পেজ ভিউ",
      orders: "অর্ডার",
      conversion: "যাঁরা অর্ডার করেছেন",
      revenue: "অর্ডারের মূল্য",
      averageOrder: "গড় অর্ডার",
      byDay: "দিন অনুযায়ী",
      day: "দিন",
      empty: "এখনো কোনো ভিজিট নেই। শুরু করতে আপনার শপের লিংক শেয়ার করুন।",
      mostViewed: "সবচেয়ে বেশি দেখা",
      bestSelling: "অনলাইনে সবচেয়ে বেশি বিক্রি",
    },
    domains: {
      title: "আপনার নিজের ডোমেইন",
      hint: "আপনার নিজের ডোমেইন ব্যবহার করুন, যেমন www.myshop.com.bd। সার্টিফিকেট আপনার জন্য তৈরি ও নবায়ন হবে।",
      planNeeded: "নিজের ডোমেইন বিজনেস প্ল্যানে পাওয়া যায়।",
      add: "ডোমেইন যোগ করুন",
      check: "এখনই দেখুন",
      makePrimary: "প্রধান ঠিকানা করুন",
      primary: "প্রধান ঠিকানা",
      dnsHint:
        "আপনার ডোমেইন প্রোভাইডারে এই রেকর্ডগুলো যোগ করুন। চালু হতে কয়েক মিনিট থেকে এক দিন লাগতে পারে; Zeeta প্রতি ঘণ্টায় দেখে।",
      type: "ধরন",
      name: "নাম",
      value: "মান",
      status: { pending: "DNS-এর অপেক্ষায়", active: "চালু", failed: "কাজ করছে না" },
    },
  },
  media: {
    add: "ছবি যোগ করুন",
    replace: "বদলান",
    uploading: "আপলোড হচ্ছে…",
    main: "প্রধান",
    makeMain: "প্রধান ছবি করুন",
  },
  couriers: {
    title: "কুরিয়ার",
    subtitle: "অর্ডার থেকে Pathao, Steadfast ও RedX পার্সেল বুক করুন এবং তাদের সংগ্রহ করা টাকার হিসাব রাখুন।",
    connect: "কুরিয়ার যুক্ত করুন",
    connectHint:
      "আপনার নিজের মার্চেন্ট অ্যাকাউন্ট ব্যবহার করুন। সংরক্ষণের আগে Zeeta কুরিয়ারের সাথে যাচাই করে এবং এনক্রিপ্ট করে রাখে।",
    provider: "কুরিয়ার",
    providers: { pathao: "Pathao", steadfast: "Steadfast", redx: "RedX" },
    where: {
      steadfast: "Steadfast মার্চেন্ট প্যানেল → API: API key ও secret key কপি করুন।",
      pathao:
        "Pathao মার্চেন্ট প্যানেল → Developers API: client ID ও secret কপি করুন। Pathao-তে যে ইমেইল ও পাসওয়ার্ড দিয়ে ঢোকেন সেটি দিন।",
      redx: "RedX মার্চেন্ট প্যানেল → Developer API: access token তৈরি করে এখানে দিন।",
    },
    labelName: "এই অ্যাকাউন্টের নাম",
    fields: {
      apiKey: "API key",
      secretKey: "Secret key",
      clientId: "Client ID",
      clientSecret: "Client secret",
      username: "Pathao লগইন ইমেইল",
      password: "Pathao পাসওয়ার্ড",
      accessToken: "Access token",
    },
    sandbox: "কুরিয়ারের টেস্ট (sandbox) সার্ভার",
    planNeeded: "কুরিয়ার সংযোগ বিজনেস প্ল্যানে পাওয়া যায়।",
    upgrade: "প্ল্যান দেখুন",
    emptyTitle: "কোনো কুরিয়ার যুক্ত নেই",
    emptyHint: "অর্ডার থেকে পার্সেল বুক করতে Pathao, Steadfast বা RedX মার্চেন্ট অ্যাকাউন্ট যুক্ত করুন।",
    disabled: "বন্ধ",
    turnOff: "বন্ধ করুন",
    turnOn: "চালু করুন",
    dueFrom: "এই কুরিয়ারের কাছে আপনার পাওনা: {amount}",
    store: "পিকআপ স্টোর",
    storeHint: "কুরিয়ার যেখান থেকে পার্সেল নেবে।",
    defaultStore: "অ্যাকাউন্টের ডিফল্ট",
    webhookSetup: "স্ট্যাটাস আপডেট (ওয়েবহুক)",
    webhookHow: {
      steadfast:
        "Steadfast প্যানেল → Webhook: URL-টি Callback URL এবং secret-টি Auth Token (Bearer) হিসেবে দিন।",
      pathao: "Pathao প্যানেল → Developers API → Webhook: URL ও secret দিয়ে Integrate চাপুন।",
      redx: "এই URL-টি RedX সাপোর্টকে আপনার callback URL হিসেবে পাঠান। Zeeta প্রতি ঘণ্টায়ও পার্সেল দেখে নেয়।",
    },
    webhookUrl: "ওয়েবহুক URL",
    webhookSecret: "ওয়েবহুক secret",
    toBePaid: "ডেলিভারি হয়েছে, টাকা এখনো পাননি",
    nothingDue: "পাওনা কিছু নেই।",
    recordPayout: "পেমেন্ট লিখুন",
    payoutHint:
      "এই পেমেন্টে যে পার্সেলগুলো আছে সেগুলো বাছুন। কুরিয়ার যা কেটে রেখেছে তা কুরিয়ার চার্জ হিসেবে লেখা হবে।",
    received: "পাওয়া টাকা",
    receivedIn: "যে অ্যাকাউন্টে এসেছে",
    collectedTotal: "এই পার্সেলগুলোর সংগ্রহ: {amount}",
    feesWillBe: "কুরিয়ার চার্জ লেখা হবে: {amount}",
    tooMuch: "এই পার্সেলগুলোর সংগ্রহের চেয়ে বেশি।",
    reference: "পেমেন্ট রেফারেন্স",
    order: "অর্ডার",
    statusCol: "অবস্থা",
    collectedShort: "সংগ্রহ",
    feeShort: "চার্জ",
    unknown: "জানানো হয়নি",
    onTheWay: "পথে আছে",
    payouts: "পেমেন্ট",
    date: "তারিখ",
    parcels: "পার্সেল",
    shipments: "কুরিয়ার",
    book: "কুরিয়ার বুক করুন",
    bookHint: "কুরিয়ার একটি কনসাইনমেন্ট তৈরি করবে এবং অর্ডারটি পাঠানো হিসেবে চিহ্নিত হবে।",
    account: "কুরিয়ার অ্যাকাউন্ট",
    city: "শহর",
    zone: "জোন",
    area: "ডেলিভারি এলাকা",
    auto: "কুরিয়ার নিজে বের করবে",
    cod: "সংগ্রহ করতে হবে",
    codHint: "এই অর্ডারে এখনো বাকি: {amount}",
    weight: "ওজন (গ্রাম)",
    note: "রাইডারের জন্য নোট",
    refresh: "এখনই অবস্থা দেখুন",
    label: "লেবেল প্রিন্ট",
    codAmount: "সংগ্রহ করতে হবে {amount}",
    collected: "সংগ্রহ হয়েছে {amount}",
    fee: "চার্জ {amount}",
    returnedHint:
      'পার্সেল ফেরত এসেছে। পণ্য স্টকে ফেরাতে ও গ্রাহকের পাওনা মুছতে উপরের "পার্সেল ফেরত এসেছে" বাটন চাপুন।',
    enterCollected: "কুরিয়ারের সংগ্রহ করা টাকা",
    status: {
      booked: "বুক হয়েছে",
      in_transit: "পথে আছে",
      hold: "হোল্ডে",
      delivered: "ডেলিভারি হয়েছে",
      partial: "আংশিক ডেলিভারি",
      returned: "ফেরত",
      cancelled: "বাতিল",
    },
  },
  developers: {
    title: "ডেভেলপার",
    subtitle: "আপনার নিজের ওয়েবসাইট, অ্যাপ বা ইন্টিগ্রেশনের জন্য API কী ও ওয়েবহুক।",
    docs: "API ডকুমেন্টেশন",
    liveNeedsPlan:
      "লাইভ কী ও ওয়েবহুকের জন্য বিজনেস প্ল্যান লাগবে। যেকোনো প্ল্যানে টেস্ট মোডে তৈরি ও পরীক্ষা করতে পারবেন।",
    keys: "API কী",
    keysHint: "সিক্রেট কী শুধু আপনার সার্ভারে রাখুন। পাবলিশেবল কী ওয়েবসাইটে ব্যবহার করা যায়।",
    createKey: "কী তৈরি করুন",
    noKeys: "এখনো কোনো API কী নেই",
    key: "কী",
    access: "অনুমতি",
    lastUsed: "শেষ ব্যবহার",
    never: "কখনো না",
    expires: "মেয়াদ শেষ {when}",
    revoke: "বাতিল করুন",
    revokeConfirm: "“{name}” বাতিল করবেন? যা এটি ব্যবহার করছে তা এক মিনিটের মধ্যে বন্ধ হয়ে যাবে।",
    webhooks: "ওয়েবহুক",
    webhooksHint: "ঘটনা ঘটার সাথে সাথে আমরা আপনার URL-এ ইভেন্ট পাঠাই, স্বাক্ষর সহ যাতে আপনি নিশ্চিত হতে পারেন।",
    addEndpoint: "এন্ডপয়েন্ট যোগ করুন",
    testSent: "টেস্ট ইভেন্ট পাঠানো হয়েছে। ডেলিভারি তালিকা দেখুন।",
    noEndpoints: "এখনো কোনো ওয়েবহুক এন্ডপয়েন্ট নেই",
    disabled: "বন্ধ",
    deliveries: "ডেলিভারি",
    sendTest: "টেস্ট পাঠান",
    signingSecret: "সাইনিং সিক্রেট",
    disable: "বন্ধ করুন",
    enable: "চালু করুন",
    deleteConfirm: "এই এন্ডপয়েন্ট ও এর ডেলিভারির ইতিহাস মুছে ফেলবেন?",
    testData: "টেস্ট ডেটা",
    testDataHint:
      "টেস্ট মোড আপনার পণ্য, শাখা, পেমেন্ট অ্যাকাউন্ট ও স্টকের একটি কপিতে কাজ করে। বর্তমান লাইভ ডেটা থেকে আবার শুরু করতে রিসেট করুন।",
    resetTestData: "টেস্ট ডেটা রিসেট",
    createTestData: "টেস্ট ডেটা তৈরি করুন",
    resetConfirm: "সব টেস্ট অর্ডার, বিক্রি ও ক্রেতা মুছে লাইভ থেকে নতুন করে কপি হবে।",
    mode: { live: "লাইভ", test: "টেস্ট" },
    kind: { publishable: "পাবলিশেবল", secret: "সিক্রেট" },
    kindHint: {
      publishable: "ওয়েবসাইটের ব্রাউজার কোডের জন্য। পণ্য দেখা ও ক্যাশ অন ডেলিভারি অর্ডার দেওয়া যায়।",
      secret: "আপনার সার্ভারের জন্য। এটি ঠিক কী কী করতে পারবে বেছে নিন।",
    },
    keyCreated: "আপনার নতুন কী",
    secretOnce: "এখনই কপি করুন। নিরাপত্তার জন্য এই সিক্রেট কী আর কখনো দেখানো হবে না।",
    nameHint: "কোথায় ব্যবহার হবে, যেমন “দোকানের ওয়েবসাইট”",
    modeLabel: "মোড",
    permissions: "অনুমতি",
    origins: "অনুমোদিত ওয়েবসাইট",
    originsHint: "প্রতি লাইনে একটি অরিজিন, যেমন https://shop.example.com",
    expiry: "মেয়াদ",
    days: "{n} দিনে",
    endpointCreated: "এন্ডপয়েন্ট যোগ হয়েছে",
    secretHint: "প্রতিটি রিকোয়েস্টের Zeeta-Signature হেডার যাচাই করতে এই সিক্রেট ব্যবহার করুন।",
    url: "এন্ডপয়েন্ট URL",
    events: "ইভেন্ট",
    rotate: "সিক্রেট বদলান",
    rotateConfirm: "আপনার রিসিভারকে সাথে সাথে নতুন সিক্রেটে যেতে হবে। চালিয়ে যাবেন?",
    noDeliveries: "এই এন্ডপয়েন্টে এখনো কিছু পাঠানো হয়নি।",
    response: "উত্তর",
    attempts: "{n} বার চেষ্টা",
    nextAttempt: "আবার চেষ্টা {when}",
    resend: "আবার পাঠান",
    scope: {
      catalog_read: "পণ্য ও স্টক দেখা",
      customers_read: "ক্রেতা দেখা",
      customers_write: "ক্রেতা তৈরি",
      orders_read: "অর্ডার দেখা",
      orders_create: "অর্ডার দেওয়া",
      orders_write: "অর্ডার দেওয়া ও বাতিল",
      sales_read: "বিক্রি দেখা",
    },
    event: {
      label: "ইভেন্ট",
      order_created: "নতুন অর্ডার এসেছে",
      order_updated: "অর্ডারের অবস্থা বদলেছে",
      sale_completed: "বিক্রি লেখা হয়েছে, কাউন্টারে বা অর্ডার থেকে",
      stock_low: "কোনো পণ্য পুনঃক্রয় সীমায় নেমেছে",
      item_updated: "পণ্যের তথ্য বা দাম বদলেছে",
      customer_created: "নতুন ক্রেতা যোগ হয়েছে",
    },
    delivery: { pending: "আবার চেষ্টা হচ্ছে", succeeded: "পৌঁছেছে", failed: "ব্যর্থ" },
  },
  apiDocs: {
    title: "API রেফারেন্স",
    introduction: "পরিচিতি",
    sdk: "TypeScript SDK",
    sdkHint: "পেজিনেশন, রিট্রাই ও আইডেমপোটেন্সি সহ একটি টাইপড ক্লায়েন্ট।",
    webhooks: "ওয়েবহুক",
    webhooksHint: "বিশ্বাস করার আগে প্রতিটি রিকোয়েস্ট যাচাই করুন।",
    objects: "অবজেক্ট",
    baseUrl: "বেস URL",
    scope: "অনুমতি",
    publishableOk: "পাবলিশেবল কী দিয়ে চলে",
    parameters: "প্যারামিটার",
    body: "রিকোয়েস্ট বডি",
    returns: "ফেরত দেয়",
    list: "একটি তালিকা",
    required: "আবশ্যক",
    default: "ডিফল্ট",
  },
  wholesale: {
    title: "পাইকারি",
    subtitle: "ডিলার ও খুচরা বিক্রেতাদের জন্য মূল্য তালিকা, সেলস রিপ্রেজেন্টেটিভ ও তাদের কমিশন।",
    priceLists: "মূল্য তালিকা",
    addList: "নতুন মূল্য তালিকা",
    listNameEn: "নাম (ইংরেজি)",
    listNameBn: "নাম (বাংলা)",
    listNameHint: "যেমন ডিলার, খুচরা বা পাইকারি।",
    listActive: "চালু আছে",
    inactive: "বন্ধ",
    listCounts: "{items}টি পণ্য · {customers} জন গ্রাহক",
    listsEmpty: "এখনো কোনো মূল্য তালিকা নেই।",
    listsEmptyTitle: "ভিন্ন গ্রাহকের কাছে ভিন্ন দামে বিক্রি করুন",
    listsEmptyHint:
      "একটি মূল্য তালিকা বানান, দাম বসান, তারপর গ্রাহকদের তালিকায় যুক্ত করুন। বিক্রির সময় তারা নিজে থেকেই সেই দাম পাবেন, অফলাইনেও।",
    gridHint: "এই তালিকায় না থাকা পণ্য সাধারণ দামে বিক্রি হবে।",
    gridEmpty: "এই তালিকায় এখনো কোনো দাম নেই। ওপরে পণ্য খুঁজে যোগ করুন।",
    addItem: "এই তালিকায় পণ্য যোগ করুন…",
    normalPrice: "সাধারণ দাম",
    listPrice: "তালিকার দাম",
    savePrices: "পরিবর্তন সংরক্ষণ ({count})",
    priceList: "মূল্য তালিকা",
    priceListHint: "বিক্রির সময় এই গ্রাহক তালিকার দাম পাবেন।",
    normalPrices: "সাধারণ দাম",
    onList: "{name} মূল্য তালিকায় কিনছেন",
    reps: "সেলস রিপ্রেজেন্টেটিভ",
    addRep: "নতুন সেলস রিপ্রেজেন্টেটিভ",
    rep: "সেলস রিপ্রেজেন্টেটিভ",
    noRep: "কোনো সেলস রিপ্রেজেন্টেটিভ নেই",
    repLabel: "রিপ্রেজেন্টেটিভ: {name}",
    repActive: "এখনো কাজ করছেন",
    repsEmpty: "এখনো কোনো সেলস রিপ্রেজেন্টেটিভ নেই",
    repsEmptyHint: "যারা আপনার হয়ে বিক্রি করেন তাদের যোগ করুন, তারপর বিক্রির সময় তাদের নাম বেছে নিন।",
    commission: "কমিশন %",
    commissionHint: "ছাড়ের পর, ভ্যাট ছাড়া ও ফেরত বাদ দিয়ে বিক্রির ওপর।",
    commissionInvalid: "০ থেকে ৫০-এর মধ্যে শতাংশ লিখুন",
    repReport: "কমিশন রিপোর্ট",
    invoices: "ইনভয়েস",
    netSales: "নিট বিক্রি",
    commissionDue: "কমিশন",
    reportEmpty: "এই সময়ে কোনো রিপ্রেজেন্টেটিভের নামে বিক্রি নেই।",
    reportNote:
      "নিট বিক্রিতে ভ্যাট ও সম্পূরক শুল্ক নেই, এবং এই সময়ের ফেরত বাদ দেওয়া হয়েছে। কমিশন খরচ থেকে পরিশোধ করুন।",
    challan: "ডেলিভারি চালান",
    challans: "ডেলিভারি চালান",
    makeChallan: "চালান তৈরি করুন",
    challanNo: "চালান নং",
    invoiceNo: "ইনভয়েস নং",
    deliverTo: "যেখানে পাঠানো হবে",
    vehicleNo: "গাড়ির নম্বর",
    driver: "চালক",
    driverName: "চালকের নাম",
    driverPhone: "চালকের ফোন",
    goods: "মালামাল",
    receivedBy: "গ্রহণকারী",
    carriedBy: "বহনকারী",
    authorisedBy: "অনুমোদনকারী",
  },
  loyalty: {
    title: "লয়্যালটি ও ভাউচার",
    subtitle: "নিয়মিত গ্রাহকদের পয়েন্ট দিন ও ডিসকাউন্ট কোড চালান।",
    points: "লয়্যালটি পয়েন্ট",
    pointsHint: "গ্রাহকরা কেনাকাটায় পয়েন্ট পান এবং পরের বার ছাড় হিসেবে ব্যবহার করেন।",
    on: "চালু করুন",
    spendPerPoint: "১ পয়েন্টের জন্য খরচ",
    pointValue: "১ পয়েন্টের মূল্য",
    minRedeemLabel: "একবারে সবচেয়ে কম যত পয়েন্ট",
    example: "{spend} খরচ করলে গ্রাহক {points} পয়েন্ট পাবেন, যা পরের বিলে {value} ছাড়।",
    vouchers: "ভাউচার",
    vouchersHint: "যে কোনো ক্যাশিয়ার দিতে পারেন এমন ডিসকাউন্ট কোড, যেমন EID500। ডিসকাউন্টের অনুমতি লাগে না।",
    vouchersEmpty: "এখনো কোনো ভাউচার নেই।",
    addVoucher: "নতুন ভাউচার",
    voucherCode: "ভাউচার কোড",
    codeHint: "৩–২৪টি অক্ষর, সংখ্যা বা -। গ্রাহক কাউন্টারে এটি বলবেন।",
    kind: "ছাড়ের ধরন",
    kindAmount: "নির্দিষ্ট টাকা",
    kindPercent: "শতাংশ",
    discountAmount: "যত টাকা ছাড়",
    discountPercent: "যত শতাংশ ছাড়",
    minSpend: "সর্বনিম্ন বিল",
    minSpendShort: "{amount} বা তার বেশি বিলে",
    maxDiscount: "সর্বোচ্চ ছাড়",
    starts: "প্রথম দিন",
    ends: "শেষ দিন",
    usageLimit: "কতবার ব্যবহার করা যাবে",
    oncePerCustomer: "প্রত্যেক গ্রাহক একবার ব্যবহার করতে পারবেন",
    voucherActive: "চালু আছে",
    discount: "ছাড়",
    valid: "মেয়াদ",
    always: "সবসময়",
    used: "ব্যবহৃত",
    off: "বন্ধ",
    expired: "মেয়াদ শেষ",
    usedUp: "শেষ",
    scheduled: "এখনো শুরু হয়নি",
    apply: "প্রয়োগ",
    voucher: "ভাউচার",
    voucherApplied: "ভাউচার {code}",
    voucherMinSpend: "কমপক্ষে {amount} বিল লাগবে",
    usePoints: "পয়েন্ট ব্যবহার ({points} আছে, মূল্য {value})",
    minRedeem: "কমপক্ষে {points} পয়েন্ট ব্যবহার করুন",
    pointsLine: "পয়েন্ট",
    pointsShort: "{n} পয়েন্ট",
    pointsUsed: "{n} পয়েন্ট ব্যবহৃত",
    pointsEarned: "এই বিলে আপনি {n} পয়েন্ট পেয়েছেন",
    customerPoints: "{n} পয়েন্ট",
    worth: "মূল্য {value}",
    adjust: "পয়েন্ট সমন্বয়",
    adjustPoints: "যোগ করার পয়েন্ট",
    adjustHint: "পয়েন্ট কমাতে মাইনাস দিন, যেমন -২০।",
    reason: "কারণ",
    pointsCol: "পয়েন্ট",
    types: {
      earn: "অর্জিত",
      redeem: "ব্যবহৃত",
      reverse: "ফেরত নেওয়া",
      adjust: "সমন্বয়",
    },
  },
  quotations: {
    title: "কোটেশন",
    subtitle: "গ্রাহকদের দামের প্রস্তাব, রাজি হলে বিক্রিতে রূপান্তর।",
    new: "নতুন কোটেশন",
    empty: "এখনো কোনো কোটেশন নেই",
    emptyHint: "গ্রাহককে দামসহ প্রস্তাব পাঠান, রাজি হলে এক ক্লিকে বিক্রি করুন।",
    number: "কোটেশন",
    status: "অবস্থা",
    all: "সব",
    open: "খোলা",
    accepted: "বিক্রি হয়েছে",
    cancelled: "বাতিল",
    expired: "মেয়াদ শেষ",
    validUntil: "মেয়াদ",
    prospect: "অথবা যিনি এখনো গ্রাহক নন তার নাম",
    price: "দাম",
    totalHint: "ভ্যাটের আগের মোট; কোটেশনে সঠিক অঙ্ক থাকবে।",
    save: "কোটেশন সংরক্ষণ",
    sheetTitle: "কোটেশন",
    to: "প্রাপক",
    vatIncluded: "দামে ভ্যাট অন্তর্ভুক্ত।",
    vatAdded: "এই দামের সাথে ভ্যাট যোগ হবে।",
    cancel: "কোটেশন বাতিল",
    convert: "এই কোটেশন বিক্রি করুন",
    convertConfirm: "বিক্রি করুন",
    convertHint: "বিক্রিতে কোটেশনের দাম থাকবে এবং মজুদ থেকে পণ্য কমবে।",
    receivedIn: "যেখানে টাকা নেওয়া হলো",
    dueNote: "{amount} গ্রাহকের বাকিতে যোগ হবে।",
    prospectMustPay: "বাকিতে বিক্রি করতে এই ব্যক্তিকে গ্রাহক হিসেবে যোগ করুন, অথবা পুরো টাকা এখন নিন।",
    viewSale: "বিক্রি দেখুন",
  },
  serials: {
    track: "প্রতিটি বিক্রিতে সিরিয়াল বা IMEI নম্বর রাখুন",
    warrantyMonths: "ওয়ারেন্টি (মাস)",
    warrantyHint: "বিক্রির দিন থেকে। না থাকলে ০।",
    entry: "সিরিয়াল বা IMEI নম্বর",
    short: "IMEI/SN",
    missing: "{n}টি IMEI / সিরিয়াল স্ক্যান বা লিখুন",
    payBlocked: "টাকা নেওয়ার আগে আরও {n}টি সিরিয়াল বা IMEI নম্বর দিন।",
    offlineLater: "অফলাইন: সিরিয়াল নম্বর পরে ইনভয়েসে লিখুন।",
    warrantyUntil: "{date} পর্যন্ত ওয়ারেন্টি",
    record: "IMEI / সিরিয়াল লিখুন",
    recordHint: "{n}টি দিন, প্রতি লাইনে একটি।",
    purchaseHint: "IMEI বা সিরিয়াল নম্বর, প্রতি লাইনে একটি",
    count: "{n}টি দেওয়া হয়েছে",
    check: "ওয়ারেন্টি যাচাই",
    checkHint: "IMEI বা সিরিয়াল নম্বর স্ক্যান বা লিখুন",
    notFound: "এই নম্বরের কোনো পণ্য এখানে কেনা বা বিক্রি হয়নি।",
    inStock: "মজুদে আছে",
    covered: "ওয়ারেন্টি আছে",
    expired: "ওয়ারেন্টি শেষ",
    noWarranty: "ওয়ারেন্টি নেই",
    soldTo: "{date} তারিখে {name}-এর কাছে বিক্রি",
    boughtFrom: "{date} তারিখে {name} থেকে কেনা",
  },
  variants: {
    title: "সাইজ ও রং: {name}",
    open: "সাইজ ও রং ({n})",
    variant: "ভ্যারিয়েন্ট",
    unnamed: "সাধারণ",
    archived: "বিক্রি বন্ধ",
    archive: "এই ভ্যারিয়েন্ট বিক্রি বন্ধ করুন",
    add: "ভ্যারিয়েন্ট যোগ করুন",
    addHint:
      "মানগুলো কমা দিয়ে লিখুন। যে কম্বিনেশন এখনো নেই সেগুলো যোগ হবে, প্রত্যেকটির আলাদা মজুদ ও বারকোড থাকবে।",
    attribute: "বৈশিষ্ট্য",
    values: "মান",
    addAttribute: "বৈশিষ্ট্য যোগ করুন",
    price: "নতুনগুলোর দাম",
    priceHint: "নতুন ভ্যারিয়েন্টের দাম {price}; পরে ওপরে যেকোনোটি বদলাতে পারবেন।",
    nothingNew: "নতুন কিছু যোগ করার নেই",
    create: "{n}টি ভ্যারিয়েন্ট যোগ করুন",
    done: "শেষ",
  },
  supportVisit: {
    bannerRead: "Zeeta সাপোর্ট ভিউ · শুধু দেখা · শেষ {time}",
    bannerWrite: "Zeeta সাপোর্ট ভিউ · পরিবর্তন সাপোর্টের নামে থাকবে · শেষ {time}",
    leave: "বের হন",
    title: "Zeeta সাপোর্ট ভিজিট",
    subtitle: "Zeetabyte-এর সাপোর্ট টিম কখন ও কেন এই ব্যবসা খুলেছে। শুরু হলেই আপনাকে ইমেইল করা হয়।",
    none: "সাপোর্ট কখনো এই ব্যবসা খোলেনি।",
    read: "শুধু দেখা",
    write: "পরিবর্তন করতে পারত",
    now: "এখন",
    end: "এখনই বন্ধ করুন",
    endedByYou: "আপনি বন্ধ করেছেন",
    full: "পূর্ণ অ্যাক্সেস",
    bannerFull: "Zeeta সাপোর্ট ভিউ · মালিকের মতো পূর্ণ অ্যাক্সেস · পরিবর্তন সাপোর্টের নামে থাকবে · শেষ {time}",
  },
  biz: {
    listHint: "{n}টি ব্যবসা",
    searchHint: "নাম, ঠিকানা, মালিকের ইমেইল বা ফোন",
    status: "অবস্থা",
    plan: "প্ল্যান",
    type: "ব্যবসার ধরন",
    anyStatus: "যেকোনো অবস্থা",
    anyPlan: "যেকোনো প্ল্যান",
    anyType: "যেকোনো ধরন",
    statuses: {
      active: "চালু",
      suspended: "স্থগিত",
      provisioning: "তৈরি হচ্ছে",
      closed: "বন্ধ",
    },
    paymentFailed: "পেমেন্ট ব্যর্থ",
    since: "{date} থেকে",
    until: "{date} পর্যন্ত",
    lastActive: "শেষ ব্যবহার",
    never: "কখনো না",
    pageOf: "{pages} পাতার {page}",
    previous: "আগের পাতা",
    next: "পরের পাতা",
    tabs: {
      summary: "সারাংশ",
      plan: "প্ল্যান ও সীমা",
      members: "সদস্য",
      billing: "বিলিং",
      sms: "এসএমএস",
      website: "ওয়েবসাইট",
      integrations: "ইন্টিগ্রেশন",
      support: "সাপোর্ট",
      audit: "অডিট",
      danger: "বিপজ্জনক",
    },
    sales30d: "বিক্রি, ৩০ দিন",
    allTimeSales: "সব বিক্রি",
    invoices: "{n}টি ইনভয়েস",
    lastSale: "শেষ বিক্রি {date}",
    limit: "সীমা",
    used: "ব্যবহৃত",
    allowed: "অনুমোদিত",
    limits: { branches: "শাখা", users: "সদস্য", items: "পণ্য" },
    counts: "{customers} গ্রাহক · {suppliers} সরবরাহকারী · {orders} অনলাইন অর্ডার · {storage} ডেটা",
    currentPlan: "{plan} প্ল্যান",
    setPlanHint: "এই ব্যবসাকে {plan}-এ নেবে। সীমা ও সুবিধা এখনই বদলাবে।",
    overrideTitle: "এই ব্যবসার জন্য বাড়তি সীমা ও সুবিধা",
    overrideHint: "প্ল্যানের সীমা রাখতে ঘর খালি রাখুন। এখানের পরিবর্তন শুধু এই ব্যবসার জন্য।",
    overrideActive: "বাড়তি সীমা চালু",
    planDefault: "প্ল্যান: {value}",
    usePlan: "প্ল্যানের সীমা",
    unlimitedHint: "সীমাহীন করতে ∞ লিখুন।",
    features: {
      vat: "ভ্যাট ও মূসক",
      offline: "অফলাইন বিক্রি",
      multi_branch: "একাধিক শাখা",
      custom_domain: "নিজস্ব ওয়েবসাইট ঠিকানা",
      api: "লাইভ API",
      couriers: "কুরিয়ার",
      advanced_reports: "উন্নত রিপোর্ট",
    },
    on: "চালু",
    asPlan: "প্ল্যান অনুযায়ী",
    forceOn: "সবসময় চালু",
    forceOff: "সবসময় বন্ধ",
    overrideNote: "কেন (স্টাফ দেখবে)",
    overrideNoteHint: "যেমন: তিন মাসের শাখা পরীক্ষা।",
    overrideExpires: "শেষ হবে",
    saveOverride: "বাড়তি সীমা সংরক্ষণ",
    saveOverrideHint: "এই ব্যবসা এখনই এই সীমা ও সুবিধা পাবে।",
    removeOverride: "বাড়তি সীমা সরান",
    memberEmail: "Gmail ঠিকানা",
    memberEmailHint: "Zeeta অ্যাকাউন্ট থাকলে সঙ্গে সঙ্গে যোগ হবে; না থাকলে ইমেইলে আমন্ত্রণ যাবে।",
    addMember: "সদস্য যোগ করুন",
    addMemberHint: "{email} {role} হিসেবে যোগ দেবেন।",
    changeRole: "ভূমিকা বদলান",
    changeRoleHint: "{name} {role} হবেন।",
    removeMember: "সদস্য সরান",
    removeMemberHint: "{name} এখনই এই ব্যবসায় অ্যাক্সেস হারাবেন।",
    revokeInvite: "আমন্ত্রণ বাতিল",
    transfer: "মালিকানা হস্তান্তর",
    transferHint: "{name} মালিক হবেন। বর্তমান মালিক ম্যানেজার হবেন। দুজনকেই ইমেইল করা হবে।",
    makeOwner: "মালিক করুন",
    remove: "সরান",
    memberSince: "সদস্য হয়েছেন",
    accountDisabled: "অ্যাকাউন্ট বন্ধ",
    invitations: "অপেক্ষমাণ আমন্ত্রণ",
    inviteExpires: "শেষ {date}",
    formerMembers: "আগের সদস্য",
    typeToConfirm: "নিশ্চিত করতে {text} লিখুন",
    totalPaid: "মোট পরিশোধ",
    payments: "পেমেন্ট",
    forWhat: "কিসের জন্য",
    smsPack: "{n} এসএমএস",
    noPayments: "এখনো কোনো পেমেন্ট নেই।",
    smsBalance: "এসএমএস ক্রেডিট",
    smsMessages: "সাম্প্রতিক বার্তা",
    smsLedger: "ক্রেডিটের হিসাব",
    grantHint: "{n} ক্রেডিট যোগ হবে (মাইনাস দিলে কমবে)।",
    websiteOpen: "খোলা",
    websiteClosed: "বন্ধ",
    visitWebsite: "ওয়েবসাইট দেখুন",
    takeOffline: "ওয়েবসাইট বন্ধ করুন",
    putOnline: "ওয়েবসাইট চালু করুন",
    noWebsite: "এই ব্যবসা ওয়েবসাইট চালু করেনি।",
    domain: "ডোমেইন",
    checked: "শেষ যাচাই",
    primary: "প্রধান",
    recheck: "আবার যাচাই",
    removeDomain: "ডোমেইন সরান",
    couriers: "কুরিয়ার",
    courierSecret: "কুরিয়ারের পাসওয়ার্ড ও কী কখনো দেখানো হয় না, স্টাফকেও না।",
    apiKeys: "API কী",
    lastUsed: "শেষ ব্যবহার {date}",
    revoked: "বাতিল",
    revoke: "বাতিল করুন",
    revokeKey: "API কী বাতিল",
    webhooks: "ওয়েবহুক",
    disable: "বন্ধ করুন",
    enable: "চালু করুন",
    none: "নেই",
    staffActions: "Zeetabyte স্টাফ যা করেছেন",
    businessLog: "ব্যবসার নিজস্ব লগ",
    auditSearch: "কাজ খুঁজুন",
    action: "কাজ",
    suspendHint: "আবার চালু না করা পর্যন্ত কেউ ব্যবসাটি ব্যবহার করতে পারবে না। ডেটা থাকবে।",
    reactivateHint: "ব্যবসাটি এখনই আবার ব্যবহার করা যাবে।",
  },
  usr: {
    limitsTitle: "ব্যবসার সীমা",
    limitsUsage: "{max}টির মধ্যে {owned}টি ব্যবসা · ফ্রি প্ল্যানে {maxFree}টির মধ্যে {free}টি",
    limitsDefault: "প্ল্যাটফর্মের সীমা প্রযোজ্য।",
    limitsCustom: "এই ব্যক্তির জন্য আলাদা সীমা।",
    limitsChange: "সীমা বদলান",
    limitsHint: "যেসব চেইন বা এজেন্সির বেশি ব্যবসা লাগে তাদের জন্য। প্ল্যাটফর্মের সীমা রাখতে ঘর খালি রাখুন।",
    limitsBlank: "খালি: প্ল্যাটফর্মের সীমা",
    listHint: "{n}টি অ্যাকাউন্ট",
    searchHint: "ইমেইল, ফোন, নাম বা ইউজার আইডি",
    everyone: "সবাই",
    active: "চালু",
    disabled: "বন্ধ",
    staffOnly: "Zeetabyte স্টাফ",
    businesses: "ব্যবসা",
    joined: "{date} যোগ দিয়েছেন",
    edit: "ইমেইল, ফোন বা নাম বদলান",
    editHint: "ইমেইল সত্যিই তার কিনা নিশ্চিত হয়েই বদলান; এটি দিয়ে তিনি সাইন ইন করেন।",
    signOut: "সব জায়গা থেকে সাইন আউট",
    signOutHint: "সব ডিভাইসের সব সেশন শেষ হবে। তিনি এখনই আবার সাইন ইন করতে পারবেন।",
    reset: "সাইন-ইন রিসেট",
    resetHint: "পাসওয়ার্ড সরিয়ে, সব জায়গা থেকে সাইন আউট করে, কোড দিয়ে সাইন ইন করতে ইমেইল পাঠাবে।",
    disable: "অ্যাকাউন্ট বন্ধ করুন",
    disableHint:
      "সব জায়গা থেকে সাইন আউট হবেন এবং আবার চালু না করা পর্যন্ত সাইন ইন করতে পারবেন না। তার ব্যবসা চলবে।",
    enable: "অ্যাকাউন্ট চালু করুন",
    signInTitle: "যেভাবে সাইন ইন করেন",
    password: "পাসওয়ার্ড",
    emailCode: "ইমেইল কোড",
    passwordChanged: "শেষ পাসওয়ার্ড বদল {date}",
    mustChange: "পরের সাইন-ইনে নতুন পাসওয়ার্ড দিতে হবে",
    removed: "সরানো হয়েছে",
    devices: "সাইন-ইন করা ডিভাইস",
    noDevices: "কোথাও সাইন ইন নেই।",
  },
  bill: {
    hint: "প্ল্যাটফর্মের সব পেমেন্ট। হাতে যাচাই করা টাকা গ্রহণ, ফেরত বা ইনভয়েস সংশোধন করতে একটি খুলুন।",
    collected: "আদায়",
    refunded: "ফেরত",
    net: "নিট",
    searchHint: "ব্যবসা, ইনভয়েস, আমাদের আইডি বা গেটওয়ে রেফারেন্স",
    kind: "কিসের জন্য",
    anyKind: "প্ল্যান ও এসএমএস",
    kinds: { subscription: "প্ল্যান", sms: "এসএমএস ক্রেডিট" },
    gateway: "যেভাবে পরিশোধ",
    anyGateway: "যেকোনো উপায়",
    manual: "স্টাফের রেকর্ড",
    statuses: { paid: "পরিশোধিত", initiated: "অপেক্ষমাণ", failed: "ব্যর্থ", cancelled: "বাতিল" },
    business: "ব্যবসা",
    refundedAmount: "{amount} ফেরত",
    reference: "রেফারেন্স",
    referenceHint: "বিকাশ/নগদ TrxID, ব্যাংক রেফারেন্স বা রসিদ নম্বর।",
    ourId: "আমাদের আইডি",
    started: "শুরু",
    paidAt: "পরিশোধ",
    payer: "পরিশোধকারী",
    billedTo: "বিল প্রাপক",
    billedToHint: "ইনভয়েসে ব্যবসার নাম ও ঠিকানার বদলে এটি দেখাবে।",
    note: "ইনভয়েসে নোট",
    refunds: "ফেরত",
    markPaid: "পরিশোধিত হিসেবে চিহ্নিত করুন",
    markPaidHint: "টাকা এসেছে নিশ্চিত হয়েই এটি করুন। প্ল্যান বা ক্রেডিট এখনই চালু হবে এবং রসিদ ইমেইল হবে।",
    markFailed: "ব্যর্থ হিসেবে চিহ্নিত করুন",
    refund: "ফেরত",
    refundHint: "যে টাকা ইতিমধ্যে ফেরত দিয়েছেন তা লিখুন। সর্বোচ্চ {max}।",
    recordRefund: "ফেরত লিখুন",
    correctInvoice: "ইনভয়েস সংশোধন",
    correctInvoiceHint: "টাকার অঙ্ক বদলায় না; ভুল হলে ফেরত দিয়ে নতুন পেমেন্ট লিখুন।",
    showRaw: "গেটওয়ের মূল উত্তর দেখুন",
    hideRaw: "গেটওয়ের মূল উত্তর লুকান",
    method: "যেভাবে পরিশোধ",
    subscription: "সাবস্ক্রিপশন",
    endsCancelled: "বাতিল, শেষ {date}",
    recordPayment: "পেমেন্ট লিখুন",
    recordHint: "Zeeta-র বাইরে দেওয়া টাকার জন্য, যেমন নগদ বা ব্যাংক ট্রান্সফার। যা কেনা হয়েছে তা এখনই চালু হবে।",
    extend: "মেয়াদ বাড়ান",
    extendHint: "পরিশোধিত মেয়াদের শেষে দিন যোগ করে, যেমন বন্ধ থাকার ক্ষতিপূরণে।",
    extraDays: "বাড়তি দিন",
    cancelAtEnd: "মেয়াদ শেষে বাতিল",
    cancelAtEndHint: "পরিশোধিত মেয়াদ পর্যন্ত চলবে, তারপর গ্রেস ছাড়াই ফ্রি প্ল্যানে যাবে।",
    resume: "বাতিল ফিরিয়ে নিন",
    cancelNow: "এখনই বাতিল",
    cancelNowHint: "ব্যবসাটি এখনই ফ্রি প্ল্যানে যাবে।",
    period: "মেয়াদ",
    credits: "এসএমএস ক্রেডিট",
  },
  platform: {
    maintenance:
      "রক্ষণাবেক্ষণের জন্য Zeeta কিছুক্ষণ শুধু দেখার মোডে আছে। সব দেখতে পারবেন, তবে পরিবর্তন একটু পরে করুন।",
    dismiss: "বন্ধ করুন",
  },
  cfg: {
    history: "পরিবর্তনের ইতিহাস",
    showChange: "পরিবর্তন দেখুন",
    noHistory: "এখনো কোনো পরিবর্তন নেই। সব ডিফল্টে আছে।",
    changed: "ডিফল্ট থেকে বদলানো",
    resetDefault: "ডিফল্টে ফেরান",
    nameEn: "নাম (ইংরেজি)",
    nameBn: "নাম (বাংলা)",
    descEn: "বিবরণ (ইংরেজি)",
    descBn: "বিবরণ (বাংলা)",
    planContents: "প্রতিটি প্ল্যানে যা আছে",
    planContentsHint:
      "সীমা, মাসিক এসএমএস ও ফিচার। এক মিনিটের মধ্যে প্ল্যানের সব ব্যবসায় পৌঁছায়; ব্যবসাভিত্তিক ব্যতিক্রম অগ্রাধিকার পায়।",
    smsPerMonth: "মাসিক এসএমএস",
    selfServe: "অনলাইনে কেনা যায়",
    resetPlan: "{plan} ডিফল্টে ফেরান",
    savePlan: "{plan} সংরক্ষণ",
    planSaveHint:
      "এই প্ল্যানের সব ব্যবসা এক মিনিটের মধ্যে নতুন সীমা ও ফিচার পাবে। কমানো সীমার বেশি থাকলে ডেটা থাকবে, তবে নতুন যোগ করা যাবে না।",
    secCodes: "সাইন-ইন কোড",
    secPasswords: "পাসওয়ার্ড",
    secSessions: "সেশন",
    secAdmin: "অ্যাডমিন কনসোল",
    sec: {
      otpTtlMinutes: "কোডের মেয়াদ (মিনিট)",
      otpMaxAttempts: "প্রতি কোডে ভুল চেষ্টা",
      otpResendSeconds: "আবার পাঠানোর আগে অপেক্ষা (সেকেন্ড)",
      otpMaxPer15Min: "১৫ মিনিটে কোড",
      otpMaxPerDay: "দিনে কোড",
      passwordMaxFailures: "বিরতির আগে ভুল পাসওয়ার্ড",
      passwordWindowMinutes: "বিরতির দৈর্ঘ্য (মিনিট)",
      sessionIdleHours: "নিষ্ক্রিয় থাকলে সাইন আউট (ঘণ্টা)",
      sessionTrustedIdleDays: "বিশ্বস্ত ডিভাইসের নিষ্ক্রিয় সীমা (দিন)",
      sessionAbsoluteDays: "আবার সাইন ইন করতে হবে (দিন)",
      adminIdleMinutes: "নিষ্ক্রিয় থাকলে অ্যাডমিন লক (মিনিট)",
      adminMaxHours: "অ্যাডমিন কোডের মেয়াদ (ঘণ্টা)",
    },
    signupTitle: "কারা যোগ দিতে পারবে",
    signup: {
      allowNewAccounts: "নতুন অ্যাকাউন্ট",
      allowNewBusinesses: "নতুন ব্যবসা",
      allowPasswordSignIn: "পাসওয়ার্ডে সাইন-ইন",
      allowGoogleSignIn: "গুগলে সাইন-ইন",
      maxBusinessesPerUser: "প্রতি জনে ব্যবসা",
      maxFreeBusinessesPerUser: "প্রতি জনে ফ্রি প্ল্যানের ব্যবসা",
    },
    signupHint: {
      allowNewAccounts: "বন্ধ থাকলে শুধু আমন্ত্রিতরা অ্যাকাউন্ট খুলতে পারবে।",
      allowNewBusinesses: "বন্ধ থাকলে নতুন ব্যবসা খোলা যাবে না। স্টাফরা পারবে।",
      allowPasswordSignIn: "বন্ধ থাকলে সবাই ইমেইল বা এসএমএস কোডে সাইন ইন করবে।",
      allowGoogleSignIn: "বন্ধ থাকলে গুগল বোতাম লুকানো থাকবে।",
    },
    limitsTitle: "সীমা",
    range: "{min} থেকে {max} এর মধ্যে। ডিফল্ট {def}।",
    outOfRange: "নিরাপদ সীমার বাইরে",
    businessLimitsHint:
      "একজন যে ব্যবসাগুলোর মালিক বা যেগুলো খুলেছেন সেগুলো গোনা হয়, বন্ধগুলো নয়। Zeeta স্টাফদের সীমা নেই; কারও সীমা বাড়াতে তার ইউজার পেজে যান।",
    securityHint:
      "প্রতিটি মান নিরাপদ সীমার মধ্যে রাখা হয় যাতে কেউ আটকে না যায়। নেটওয়ার্ক রেট লিমিট ক্লাউডফ্লেয়ারে নির্দিষ্ট, এখানে বদলানো যায় না।",
    securitySaveHint:
      "নতুন সীমা পরের সাইন-ইন বা কোড অনুরোধ থেকে প্রযোজ্য। চলমান সেশনের মেয়াদ পরের রিফ্রেশ পর্যন্ত আগের মতো থাকবে।",
    maintenanceHint:
      "কিছু ঠিক করার সময় অ্যাপ শুধু-দেখার করে দিন। সবাই সব দেখতে পারবে; আপনার বার্তাসহ সংরক্ষণ বন্ধ থাকবে। সাপোর্ট ভিজিটে প্রভাব নেই।",
    everyBusiness: "সব ব্যবসা",
    readOnlyNow: "এখন শুধু-দেখার",
    workingNormally: "স্বাভাবিকভাবে চলছে",
    endMaintenance: "রক্ষণাবেক্ষণ শেষ করুন",
    startMaintenance: "রক্ষণাবেক্ষণ শুরু করুন",
    messageEn: "বার্তা (ইংরেজি)",
    messageBn: "বার্তা (বাংলা)",
    messageHint: "ব্যানারে এবং সংরক্ষণের চেষ্টা করলে দেখানো হয়।",
    saveMessage: "বার্তা সংরক্ষণ",
    someBusinesses: "আলাদা ব্যবসা",
    someBusinessesHint: "{n}টি ব্যবসা আলাদাভাবে শুধু-দেখার। ব্যবসার ঝুঁকিপূর্ণ ট্যাব থেকে বদলান।",
    startHint:
      "সব ব্যবসা একসাথে শুধু-দেখার হবে: রক্ষণাবেক্ষণ শেষ না করা পর্যন্ত বিক্রি, স্টক পরিবর্তন ও অনলাইন অর্ডার বন্ধ থাকবে।",
    readOnlyBusiness: "শুধু-দেখার করুন",
    readOnlyBusinessHint:
      "শুধু এই ব্যবসার সংরক্ষণ রক্ষণাবেক্ষণ বার্তাসহ বন্ধ রাখুন। দেখা চলবে, সাপোর্ট ভিজিটে প্রভাব নেই।",
    endReadOnly: "শুধু-দেখার শেষ করুন",
    announceHint: "অ্যাপের ভেতরে সবাইকে বা নির্দিষ্ট প্ল্যান, ব্যবসার ধরন বা ব্যবসাকে দেখানো ব্যানার।",
    newAnnouncement: "নতুন ঘোষণা",
    severity: { info: "তথ্য", warning: "সতর্কতা", critical: "জরুরি" },
    live: "চালু",
    scheduled: "নির্ধারিত",
    ended: "শেষ",
    endNow: "এখনই শেষ করুন",
    audience: {
      all: "সবাই",
      plans: "প্ল্যান",
      packs: "ব্যবসার ধরন",
      tenants: "নির্বাচিত ব্যবসা",
    },
    noAnnouncements: "এখনো কোনো ঘোষণা নেই।",
    titleEn: "শিরোনাম (ইংরেজি)",
    titleBn: "শিরোনাম (বাংলা)",
    bodyEn: "লেখা (ইংরেজি)",
    bodyBn: "লেখা (বাংলা)",
    severityLabel: "গুরুত্ব",
    audienceLabel: "কারা দেখবে",
    businessIds: "ব্যবসার আইডি",
    businessIdsHint: "কমা বা স্পেস দিয়ে আলাদা করুন। আইডি ব্যবসার পাতার ঠিকানায় আছে।",
    starts: "শুরু",
    ends: "শেষ",
    dismissible: "লুকানো যাবে",
    typesHint:
      "প্রতিটি ব্যবসার ধরন সাইন-আপে কী দেখায় ও নতুন ব্যবসাকে কী দেয়। পরিবর্তন নতুন ব্যবসায় প্রযোজ্য; আগের ব্যবসায় নতুন ক্যাটাগরি, একক ও ঘর যোগ করতে “বিদ্যমান ব্যবসায় যোগ করুন” ব্যবহার করুন।",
    hidden: "লুকানো",
    offered: "ব্যবসা খোলার সময় দেখানো হয়",
    modules: "ডিফল্টে চালু",
    module: {
      variants: "সাইজ ও রং",
      batches: "ব্যাচ",
      expiry: "মেয়াদ",
      serials: "সিরিয়াল নম্বর",
      vat: "ভ্যাট",
      multi_branch: "শাখা",
      storefront: "অনলাইন দোকান",
      loans: "ঋণ",
    },
    categories: "শুরুর ক্যাটাগরি",
    pairHint: "প্রতি লাইনে: English | বাংলা",
    units: "একক",
    unitsHint: "প্রতি লাইনে: code | English | বাংলা | yes/no (ভগ্নাংশ চলবে কিনা)",
    conversions: "একক রূপান্তর",
    conversionsHint: "প্রতি লাইনে: from > to = সংখ্যা, যেমন kg > g = 1000",
    priceTiers: "শুরুর মূল্য তালিকা",
    presets: "সাইজ ও রঙের প্রিসেট",
    presetsHint: "প্রতি লাইনে: English | বাংলা: মান, মান",
    warranty: "ডিফল্ট ওয়ারেন্টি (মাস)",
    nearExpiry: "মেয়াদ শেষের সতর্কতা (দিন)",
    customFields: "অতিরিক্ত ঘর",
    fieldKey: "ঘরের কী",
    fieldFor: "যেখানে ব্যবহার",
    fieldType: "ঘরের ধরন",
    entity: { item: "পণ্য", customer: "গ্রাহক", supplier: "সরবরাহকারী" },
    type: { text: "লেখা", number: "সংখ্যা", date: "তারিখ", select: "তালিকা", boolean: "হ্যাঁ/না" },
    required: "আবশ্যক",
    searchable: "খোঁজা যাবে",
    options: "তালিকার বিকল্প",
    addField: "ঘর যোগ করুন",
    applyExisting: "বিদ্যমান ব্যবসায় যোগ করুন",
    applyHint:
      "{name} থেকে অনুপস্থিত ক্যাটাগরি, একক, রূপান্তর ও অতিরিক্ত ঘর এই ধরনের সব ব্যবসায় যোগ হবে। কিছু বদলানো বা মোছা হবে না।",
    saveType: "{name} সংরক্ষণ",
    saveTypeHint: "এই ধরনের নতুন ব্যবসা এই সেটিংস দিয়ে শুরু হবে। বিদ্যমান ব্যবসা বদলাবে না।",
  },
  life: {
    export: "সব ডেটা এক্সপোর্ট",
    exportHint: "প্রতিটি টেবিল CSV ফাইল হিসেবে একটি zip-এ, ৭ দিন রাখা হয়। তৈরি হলে ইমেইল পাবেন।",
    exportConfirm: "এই ব্যবসার প্রতিটি টেবিল একটি zip ফাইলে লেখা হবে। ডাউনলোড অডিট লগে থাকে।",
    close: "ব্যবসা বন্ধ করুন",
    closeHint:
      "সদস্যরা আর খুলতে পারবে না, এপিআই কী বাতিল, ওয়েবহুক ও অনলাইন দোকান বন্ধ। ডেটা ৩০ দিন রাখা হয়, তারপর স্থায়ীভাবে মুছে যায়।",
    closeConfirm:
      "{name} এখনই বন্ধ হবে এবং মালিকদের ইমেইল করা হবে। ৩০ দিন পর্যন্ত ফিরিয়ে আনা যাবে; তারপর সব ডেটা মুছে যাবে।",
    closedTitle: "এই ব্যবসা বন্ধ",
    closedHint: "{closed} তারিখে বন্ধ হয়েছে। ফিরিয়ে আনা না হলে {purge} তারিখে ডেটা মুছে যাবে।",
    restore: "ব্যবসা ফিরিয়ে আনুন",
    restoreConfirm: "ব্যবসা সব ডেটা, অনলাইন দোকান ও ওয়েবহুকসহ আগের মতো খুলবে। এপিআই কী বাতিলই থাকবে।",
    purged: "এই ব্যবসার ডেটা মুছে ফেলা হয়েছে",
    purgedHint: "{date} তারিখে মোছা হয়েছে। বিলিং ইতিহাস ও অডিট লগ রাখা আছে।",
  },
  dataExport: {
    title: "আপনার ডেটা",
    hint: "Zeeta-তে আপনার ব্যবসার সব ডেটা স্প্রেডশিট (CSV) ফাইলের zip হিসেবে ডাউনলোড করুন। পণ্যের ছবি থাকে না।",
    open: "সব ডেটা ডাউনলোড",
    prepare: "ডাউনলোড তৈরি করুন",
    preparing: "তৈরি হচ্ছে…",
    none: "এখনো কোনো ডাউনলোড নেই।",
    noPermission: "ব্যবসার ডেটা ডাউনলোডের অনুমতি আপনার নেই।",
    status: { queued: "তৈরি হচ্ছে", ready: "প্রস্তুত", failed: "ব্যর্থ" },
    expired: "মেয়াদ শেষ",
    byStaff: "Zeeta সাপোর্ট দ্বারা",
    tables: "{n}টি টেবিল",
    until: "{date} পর্যন্ত",
    download: "ডাউনলোড",
  },
  dash: {
    period: "সময়কাল",
    days: "{n} দিন",
    netRevenue: "নিট আয়, {n} দিন",
    signups: "নতুন ব্যবসা, {n} দিন",
    vsPrevious: "আগের সময়ের তুলনায় {pct}",
    newThisPeriod: "আগের সময়ে কিছু ছিল না",
    noChange: "পরিবর্তন নেই",
    ofBusinesses: "{n}টি সক্রিয় ব্যবসার মধ্যে",
    activeToday: "আজ সক্রিয় ব্যবসা",
    statusSplit: "{suspended}টি স্থগিত · {closed}টি বন্ধ",
    revenueByDay: "দিনভিত্তিক আয়",
    signupsByDay: "দিনভিত্তিক নতুন ব্যবসা",
    revenueByPlan: "প্ল্যানভিত্তিক আয়",
    smsPacks: "এসএমএস প্যাক",
    payments: "{n}টি পেমেন্ট",
    noRevenue: "এই সময়ে কোনো পেমেন্ট নেই।",
    refundsNote: "{gross} আদায়, {refunds} ফেরত। চার্টে আদায়ের হিসাব।",
    needsAttention: "মনোযোগ দরকার",
    failedPayments: "ব্যর্থ পেমেন্ট, {n} দিন",
    errors24h: "খোলা ত্রুটি, গত ২৪ ঘণ্টা",
    openVisits: "এখন চলমান সাপোর্ট ভিজিট",
    nearLimits: "প্ল্যানের সীমার কাছে থাকা ব্যবসা",
    nearLimitsHint: "কোনো সীমার ৮০% বা বেশি। ব্যবহার প্রতি রাতে এবং ব্যবসা খুললে হালনাগাদ হয়।",
    smsLine: "এই সময়ে {n}টি এসএমএস ({segments} সেগমেন্ট), {failed}টি ব্যর্থ।",
  },
  logs: {
    staff: "স্টাফ",
    staffPlaceholder: "স্টাফের ইমেইল",
    action: "কাজ",
    allActions: "সব কাজ",
    businessId: "ব্যবসার আইডি",
    business: "ব্যবসা",
    from: "থেকে",
    to: "পর্যন্ত",
    csv: "CSV ডাউনলোড",
    system: "সিস্টেম",
    empty: "এই ফিল্টারে কিছু মেলেনি।",
    loadMore: "আরও দেখুন",
    errors: {
      open: "খোলা",
      resolved: "সমাধান হয়েছে",
      noneResolved: "গত ৭ দিনে সমাধান হওয়া কোনো ত্রুটি নেই।",
      reopened: "আবার ঘটেছে",
      resolve: "সমাধান হয়েছে চিহ্নিত করুন",
      reopen: "আবার খুলুন",
      note: "কী দিয়ে ঠিক হলো (ঐচ্ছিক)",
      resolvedBy: "{date} তারিখে {who} সমাধান চিহ্নিত করেছেন",
    },
  },
  ai: {
    ask: "Zeeta-কে জিজ্ঞেস করুন",
    intro: "বিক্রি, স্টক, বাকি বা খরচ নিয়ে বাংলা বা ইংরেজিতে জিজ্ঞেস করুন। উত্তর আসে আপনার নিজের রিপোর্ট থেকে।",
    suggest: {
      today: "আজ বিক্রি কেমন হলো?",
      week: "গত সপ্তাহের তুলনায় এই সপ্তাহে কত বিক্রি হলো?",
      dues: "কার কাছে সবচেয়ে বেশি বাকি?",
      runningOut: "কোন পণ্য শীঘ্রই শেষ হয়ে যাবে?",
      bestSellers: "এই মাসে সবচেয়ে বেশি বিক্রি হয়েছে কোনগুলো?",
    },
    question: "আপনার প্রশ্ন",
    placeholder: "প্রশ্ন লিখুন…",
    listening: "শুনছি…",
    speak: "প্রশ্নটি বলুন",
    stopListening: "শোনা বন্ধ করুন",
    send: "পাঠান",
    thinking: "আপনার রিপোর্ট দেখছি…",
    remaining: "এই মাসে {quota}টির মধ্যে {n}টি এআই অনুরোধ বাকি।",
    privacy: "গ্রাহক ও সরবরাহকারীর নাম কখনো এআই প্রদানকারীর কাছে পাঠানো হয় না।",
    notInPlan: "আপনার প্ল্যানে Zeeta-কে জিজ্ঞেস করা নেই। ব্যবহার করতে বিলিং পাতা থেকে আপগ্রেড করুন।",
    unavailable: "এই মুহূর্তে Zeeta-কে জিজ্ঞেস করা যাচ্ছে না। পরে আবার চেষ্টা করুন।",
  },
  aiAdmin: {
    hint: "এআই ফিচার Cloudflare AI-এর মাধ্যমে OpenAI-এর GPT-6 Luna ব্যবহার করে, বিল আসে Cloudflare অ্যাকাউন্টে। প্রশ্নের উত্তর দিতে দোকানের হিসাব ও পণ্যের নাম পাঠানো হয়; গ্রাহক, সরবরাহকারী ও স্টাফের নাম, ফোন নম্বর ও ঠিকানা পাঠানো হয় না।",
    connected: "সংযুক্ত · {model}",
    notConfigured: "সেট আপ হয়নি",
    setupHint:
      'এই এনভায়রনমেন্টে Cloudflare AI বাইন্ডিং নেই (wrangler.jsonc-তে "ai": { "binding": "AI" })। তার আগ পর্যন্ত এআই ফিচার লুকানো থাকবে।',
    enabled: "সব ব্যবসার জন্য এআই ফিচার চালু",
    weekly: "মালিকদের সাপ্তাহিক সারাংশ ইমেইল করুন",
    quota: "প্ল্যানভিত্তিক মাসিক এআই অনুরোধ",
    quotaHint: "০ দিলে ওই প্ল্যানে এআই বন্ধ। সাপ্তাহিক সারাংশ সীমায় গোনা হয় না।",
    save: "এআই সেটিংস সংরক্ষণ",
    requests30: "অনুরোধ, ৩০ দিন",
    cost30: "খরচ, ৩০ দিন",
    tokens: "টোকেন",
    errors: "ব্যর্থ অনুরোধ",
    byFeature: "ফিচারভিত্তিক",
    byBusiness: "খরচে শীর্ষ ব্যবসা",
    requests: "অনুরোধ",
    cost: "খরচ",
    feature: {
      ask: "Zeeta-কে জিজ্ঞেস",
      item: "পণ্য সহকারী",
      invoice: "ইনভয়েস পাঠক",
      summary: "সাপ্তাহিক সারাংশ",
    },
  },
  aiItem: {
    suggest: "বিবরণ সাজেস্ট করুন",
    check: "এআই সাজেস্ট করেছে। সংরক্ষণের আগে নাম, ক্যাটাগরি ও একক দেখে নিন।",
  },
  aiInvoice: {
    scan: "ইনভয়েস স্ক্যান",
    reading: "ইনভয়েস পড়া হচ্ছে…",
    photo: "ইনভয়েসের ছবি",
    unreadable: "ছবিটি ইনভয়েস হিসেবে পড়া যায়নি। ভালো আলোতে সমান করে পরিষ্কার ছবি তুলুন।",
    filled: "ইনভয়েস থেকে {total}টির মধ্যে {n}টি লাইন পূরণ হয়েছে।",
    supplierNotFound: 'সরবরাহকারী "{name}" আপনার তালিকায় নেই। একজন বেছে নিন বা যোগ করুন।',
    notMatched:
      "এই লাইনগুলো আপনার কোনো পণ্যের সাথে মেলেনি। সার্চ বক্স দিয়ে যোগ করুন, বা আগে পণ্যগুলো তৈরি করুন:",
    totalDiffers: "ইনভয়েসের মোট {read}, কিন্তু এই লাইনগুলোর মোট {now}। পরিমাণ ও দাম দেখে নিন।",
    check: "এআই পড়েছে। সংরক্ষণের আগে প্রতিটি লাইন কাগজের সাথে মিলিয়ে নিন।",
  },
  aiDigest: {
    title: "এই সপ্তাহের সারাংশ",
    week: "{from} – {to}",
    setting: "সাপ্তাহিক সারাংশ ইমেইল করুন",
    settingHint:
      "প্রতি শনিবার সকালে: বিক্রি কেমন হলো, সেরা পণ্য, কী অর্ডার করতে হবে আর কার কাছে বাকি। মালিকদের পাঠানো হয়।",
  },
  printer: {
    title: "রসিদ প্রিন্টার",
    hint: "আগে ফোনের ব্লুটুথ সেটিংসে প্রিন্টারটি পেয়ার করুন, তারপর এখানে খুঁজুন। প্রতিটি ফোনে আলাদা প্রিন্টার রাখা হয়।",
    settingsHint:
      "Zeeta অ্যান্ড্রয়েড অ্যাপে রসিদ সরাসরি ব্লুটুথ থার্মাল প্রিন্টারে বাংলাসহ প্রিন্ট হয়, আর ক্যাশ ড্রয়ার খোলে।",
    open: "রসিদ প্রিন্টার সেট আপ করুন",
    browserOnly: "সরাসরি ব্লুটুথ প্রিন্ট Zeeta Inventory Management অ্যান্ড্রয়েড অ্যাপে কাজ করে।",
    browserHint: "ব্রাউজারে রসিদ প্রিন্ট স্ক্রিন দিয়ে প্রিন্ট হয়: সেখানে প্রিন্টার বাছুন, কাগজ ৫৮ বা ৮০ মিমি রাখুন।",
    find: "পেয়ার করা প্রিন্টার খুঁজুন",
    pair: "নতুন প্রিন্টার পেয়ার করুন",
    noneFound:
      "কোনো পেয়ার করা ডিভাইস নেই। ব্লুটুথ সেটিংসে প্রিন্টার পেয়ার করুন (পিন সাধারণত ০০০০ বা ১২৩৪), তারপর আবার চেষ্টা করুন।",
    choose: "প্রিন্টার বাছুন",
    current: "প্রিন্টার",
    paper: "কাগজের প্রস্থ",
    autoPrint: "বিক্রি শেষ হলেই রসিদ প্রিন্ট করুন",
    drawer: "নগদ বিক্রিতে ক্যাশ ড্রয়ার খুলুন",
    test: "টেস্ট প্রিন্ট",
    testLine: "টেস্ট প্রিন্ট",
    testOk: "এটা পড়তে পারলে প্রিন্টার প্রস্তুত।",
    testSent: "প্রিন্টারে টেস্ট পাঠানো হয়েছে।",
    saved: "প্রিন্টার এই ফোনে সংরক্ষিত হয়েছে।",
    forget: "প্রিন্টার মুছুন",
    failed: "প্রিন্টার সাড়া দেয়নি। চালু, কাছে আর পেয়ার করা আছে কিনা দেখুন।",
  },
  labels: {
    rollTitle: "থার্মাল স্টিকার রোল",
    rollHint:
      "আপনার রোলে লেখা স্টিকারের মাপ বাছুন। লেআউট মাপ অনুযায়ী মিলে যায়: ছোট স্টিকারে নাম, দাম আর বারকোড থাকে; বড়গুলোতে দোকানের নামসহ আরও থাকে।",
    size: "স্টিকারের মাপ",
    columns: "পাশাপাশি স্টিকার",
    columnGap: "পাশের ফাঁক (মিমি)",
    tooWide: "এটি {mm} মিমি চওড়া, লেবেল প্রিন্টার এত চওড়া প্রিন্ট করে না। পাশাপাশি স্টিকার কমান।",
    previewHint: "আসল মাপে দেখানো হয়েছে: প্রিন্টার ঠিক এটাই পায়।",
    printComputer: "{n}টি স্টিকার প্রিন্ট করুন",
    printBluetooth: "ব্লুটুথে প্রিন্ট ({name})",
    computerHint:
      "কম্পিউটারে প্রিন্ট ডায়ালগে আপনার লেবেল প্রিন্টার বাছুন, কাগজের মাপ স্টিকারের মাপে দিন (বেশিরভাগ লেবেল প্রিন্টার ড্রাইভারে থাকে), স্কেল ১০০% আর মার্জিন নেই।",
    rollInUse: "ব্যবহৃত রোল: {size}, পাশাপাশি {n}টি। লেবেল প্রিন্ট পাতায় বদলান।",
    title: "লেবেল প্রিন্ট",
    hint: "পণ্যের বারকোড স্টিকার। যে পণ্যের বারকোড নেই সেটি দোকানের নিজস্ব বারকোড পাবে (২০ দিয়ে শুরু), যা সাথে সাথে ক্যাশে স্ক্যান হয়।",
    add: "প্রিন্টের জন্য পণ্য যোগ করুন…",
    empty: "যে পণ্যগুলোর স্টিকার লাগবে সেগুলো যোগ করুন।",
    barcode: "বারকোড",
    copies: "স্টিকার",
    newBarcode: "নতুন বারকোড",
    nameIn: "পণ্যের নাম",
    showShop: "দোকানের নাম",
    showPrice: "দাম",
    showMrp: "এমআরপি",
    mrp: "এমআরপি",
    preview: "দেখুন",
    sheetTitle: "A4 স্টিকার শিট",
    sheetHint:
      "যেকোনো প্রিন্টারে। নিচের মাপের A4 লেবেল শিট কিনুন, প্রিন্ট স্কেল ১০০% (ফিট টু পেজ নয়) আর মার্জিন নেই রাখুন।",
    sheet: "শিট",
    sheetOption: "প্রতি শিটে {n}টি ({size} মিমি)",
    skip: "আগেই ব্যবহৃত",
    skipHint: "আংশিক ব্যবহৃত শিটে যতগুলো স্টিকার বাদ যাবে।",
    printSheet: "{n}টি স্টিকার প্রিন্ট করুন ({pages} পাতা)",
    printerTitle: "লেবেল প্রিন্টার",
    printerHint:
      "ব্লুটুথ লেবেল প্রিন্টার (বেশিরভাগ TSPL), বা স্টিকার কাগজ লাগানো রসিদ প্রিন্টার। রোলে লেখা স্টিকারের মাপ দিন।",
    printerNone: "এই ফোনে এখনো লেবেল প্রিন্টার বাছাই হয়নি।",
    printingProgress: "{total}টির মধ্যে {done}টি প্রিন্ট হচ্ছে…",
    back: "পণ্যে ফিরে যান",
    print: "লেবেল প্রিন্ট",
    forPurchase: "এই ক্রয়ের লেবেল",
    printerKind: "প্রিন্টারের ধরন",
    kindTspl: "লেবেল প্রিন্টার (TSPL)",
    kindEscpos: "স্টিকার কাগজসহ রসিদ প্রিন্টার",
    width: "স্টিকারের প্রস্থ (মিমি)",
    height: "স্টিকারের উচ্চতা (মিমি)",
    gap: "ফাঁক (মিমি)",
  },
  scan: {
    notFound: "{code} বারকোডের কোনো পণ্য নেই",
    camera: "ক্যামেরা দিয়ে স্ক্যান",
    cameraHint: "প্রতিটি বারকোড ফ্রেমের ভেতরে ধরুন; পড়া মাত্রই যোগ হবে। স্ক্যান করতে থাকুন, শেষে শেষ চাপুন।",
    cameraDenied: "ক্যামেরার অনুমতি দেওয়া হয়নি। ব্রাউজার বা অ্যাপের সেটিংসে এই সাইটের জন্য ক্যামেরা চালু করুন।",
    cameraFailed: "এই ডিভাইসে ক্যামেরা চালু করা যায়নি।",
    torch: "আলো",
    cameraTips:
      "এখনো পড়ছে না? বারকোডটি লাল দাগ বরাবর সোজা করে, প্রায় ১৫ সেমি (এক হাত-চওড়া) দূরে, ভালো আলোতে ধরুন। অন্ধকার হলে আলো চাপুন। অথবা এটি বন্ধ করে দাগের নিচের নম্বরটি টাইপ করুন।",
    added: "{name} যোগ হয়েছে · {n}টি স্ক্যান",
    done: "শেষ",
    multiplyHint:
      "স্ক্যানার বা ক্যামেরা বোতাম দিয়ে পণ্য স্ক্যান করুন। একই পণ্য অনেকগুলো হলে সংখ্যা আর * লিখুন (যেমন 12*), তারপর স্ক্যান করুন।",
  },
  adminPin: {
    wrong: "ভুল পিন। আর {n} বার চেষ্টা করা যাবে।",
    title: "আনলক পিন",
    hint: "অ্যাডমিন নিজে থেকে লক হলে ইমেইলের অপেক্ষা ছাড়াই ৬ অঙ্কের পিন দিয়ে খোলা যায়। কোনো ব্রাউজারে ইমেইল কোড নিশ্চিত করার পর ৭ দিন সেখানে পিন কাজ করে; নতুন ব্রাউজারে প্রথমে কোড লাগবেই।",
    notSet: "এখনো পিন নেই: প্রতিবার খুলতে ইমেইল কোড লাগবে।",
    isSet: "পিন সেট করা আছে। বদলালে বা মুছলে আপনাকে ইমেইলে জানানো হবে।",
    pin: "পিন (৬ অঙ্ক)",
    newPin: "নতুন পিন (৬ অঙ্ক)",
    again: "একই পিন আবার",
    mismatch: "দুটি পিন আলাদা",
    set: "পিন সেট করুন",
    change: "পিন বদলান",
    remove: "পিন মুছুন",
    saved: "পিন সংরক্ষিত হয়েছে।",
    removed: "পিন মুছে ফেলা হয়েছে।",
    unlockTitle: "অ্যাডমিন লক",
    unlockHint: "{email} হিসেবে চালিয়ে যেতে পিন দিন।",
    unlock: "খুলুন",
    useEmail: "বরং ইমেইল কোড ব্যবহার করুন",
    usePin: "বরং আমার পিন দিয়ে খুলুন",
    tooManyTries: "অনেকবার ভুল পিন। একটি ইমেইল কোড নিশ্চিত করলে পিন আবার কাজ করবে।",
    emailDue: "একটি ইমেইল কোড নিশ্চিত করলে এই ব্রাউজারে পিন আবার কাজ করবে (প্রতি ৭ দিনে একবার লাগে)।",
    setLater: "পরামর্শ: অ্যাডমিন অ্যাকাউন্ট পাতায় আনলক পিন সেট করলে পরেরবার এই ইমেইল লাগবে না।",
  },
  barcodeLib: {
    hint: "দোকানগুলোর যোগ করা কারখানার বারকোড: শুধু নাম, ব্র্যান্ড ও মাপ, দাম বা কোন দোকান তা কখনো নয়। অনুমোদিতগুলো সব দোকানের পণ্য ফর্মে পূরণ হয়।",
    status: "অবস্থা",
    pending: "অপেক্ষায়",
    approved: "অনুমোদিত",
    rejected: "বাতিল",
    search: "বারকোড, নাম বা ব্র্যান্ড",
    empty: "এখানে কিছু নেই।",
    shops: "{n}টি দোকান যোগ করেছে",
    size: "প্যাকের মাপ",
    approve: "অনুমোদন",
    update: "পরিবর্তন সংরক্ষণ",
    reject: "বাতিল করুন",
  },
  businessLimit: {
    title: "আপনার সীমা পূর্ণ হয়েছে",
    paused: "নতুন ব্যবসা খোলা এখন বন্ধ আছে। পরে আবার চেষ্টা করুন।",
    max: "আপনি সর্বোচ্চ {max}টি ব্যবসা রাখতে পারবেন।",
    maxHelp: "যেটি আর ব্যবহার করেন না সেটি বন্ধ করুন, অথবা বড় চেইন হলে Zeeta সাপোর্টে যোগাযোগ করুন।",
    free: "ফ্রি প্ল্যানে আপনি {count}টি ব্যবসা রাখতে পারবেন।",
    noFree: "নতুন ব্যবসার জন্য পেইড প্ল্যান লাগবে।",
    freeHelp: "আপনার ফ্রি ব্যবসাটি পেইড প্ল্যানে নিলে আরেকটি ব্যবসা খুলতে পারবেন।",
    upgrade: "{name} আপগ্রেড করুন",
  },
  scanTest: {
    title: "বারকোড স্ক্যানার পরীক্ষা করুন",
    hint: "বক্সে ক্লিক করে যেকোনো পণ্য স্ক্যান করুন। স্ক্যানার কী পাঠায় দেখতে পাবেন।",
    placeholder: "এখানে স্ক্যান করুন",
    code: "কোড",
    kind: "ধরন",
    factory: "কোম্পানির বারকোড (খোঁজা যায়)",
    shopCode: "দোকানের নিজের বারকোড",
    other: "অন্য কোড বা SKU",
    speed: "গতি",
    ms: "প্রতি অক্ষরে {ms} মি.সে.",
    ending: "শেষে",
    end: { enter: "Enter", tab: "Tab", none: "কিছু না" },
    raw: "যেভাবে টাইপ হয়েছে",
    ok: "এই স্ক্যানার Zeeta-তে কাজ করে।",
    tooSlow:
      "এই স্ক্যানার ধীরে টাইপ করে। কার্সর বারকোড বক্সে থাকলে স্ক্যান কাজ করবে। যেকোনো জায়গা থেকে স্ক্যান করতে এটিকে দ্রুত (high-speed USB) মোডে সেট করুন (ম্যানুয়াল দেখুন)।",
    bangla: "বাংলা কীবোর্ড চালু আছে। Zeeta অঙ্কগুলো ঠিকভাবে পড়ে, তবে স্ক্যানের সময় ইংরেজিতে রাখা সবচেয়ে নিরাপদ।",
  },
  theme: {
    label: "চেহারা",
    light: "লাইট",
    dark: "ডার্ক",
    system: "ডিভাইসের সেটিং",
  },
  roles: {
    owner: "মালিক",
    manager: "ম্যানেজার",
    cashier: "ক্যাশিয়ার",
    stock_keeper: "স্টক কিপার",
    accountant: "হিসাবরক্ষক",
    support: "Zeeta সাপোর্ট",
  },
};
